import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import {
  Paper,
  FormControl,
  FormControlLabel,
  Button,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Switch,
  Checkbox,
  ListItemText,
  Box,
  Chip
} from "@material-ui/core";
import {preventDoubleClick} from "./preventDC.js"
import {CSVLink} from "react-csv"
import { useAppData } from "./appDataContext.js";
import {
  searchLeadsbyDate,
  searchLeadsbyDate3,
  searchTripsbyDate2,
  searchconvTripsbyDate,
  searchconvTripsbyDate2,
  searchcancTripsbyDate,
  searchhotTripsbyDate,
  searchhotTripsbyDate2,
  searchActiveTripsbyDate,
  fetchEmployees,
  searchQuotesbyDate,
  fetchDest,
  TestTC,
  searchboTripsbyDate2,
  searchQCbyDate,
  newsearchQEbyDate,
  fetchconvdate,
  searchsuperhotTripsbyDate,
  fetchquotefromtrip,
  searchpotentialTripsbyDate,
  fetchleadsbydate2,
  fetchleadsbynumber2,
  fetchTripsbyNumber2,
  searchConvTripsbyStartDate,
  searchclosedTripsbyDate,
  fetchTripsbyCompetitionDate,
  gettripfromleadidlist, getlpdata,
  
} from "../api/customerapi";
import { DataGrid } from "@mui/x-data-grid";
import Median from "./median.js";
import GetRole from "./user";
import DateCalc, {calculateAveragewithoutzero, calculateAverage, DateCalc2, getquality, removeDuplicates, getmonth, countTextValues, getconvdatearray, getprofit, gethotdatearray, getconvdate, getcancdate, filterQuotes, gethotdate, newgetqualitylead, sslist, getUnique} from "./date";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
  headertext: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(24),
    height: theme.spacing(5),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    fontSize: 14,
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(24),
    height: theme.spacing(5),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(1),
    fontSize: 14,
  },
}));

const Analytics2 = () => {
  const width = window.innerWidth - 200;
  const cheaders=[
    {label:"Quote Id", key:"quote_id"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Trip Owner", key:"owner"},
    {label:"Destination", key:"destination"},
    {label:"Trip Status", key:"status"},
    {label:"Adult", key:"adult"},
    {label:"Child", key:"child"},
    {label:"Duration", key:"duration"},
    {label:"Name", key:"cust_name"},
    {label:"Flight SP", key:"flight_sp"},
    {label:"FLight PP", key:"flight_pp"},
    {label:"Land SP", key:"land_sp"},
    {label:"Land PP", key:"land_pp"},
    {label:"FLight Profit", key:"flight_profit"},
    {label:"Land Profit", key:"land_profit"},
    {label:"Land Profit %", key:"land_profit_perc"},
    {label:"Header", key:"header"},
    {label:"Canc Reason", key:"canc_reason"},
    {label:"Conv Quote", key:"conv_quote"},
]
  const columns2 = [
    {
      field: "day",
      headerName: " Days to Convert",
      width: (width / 12) * 3,
      cellClassName: "gridcell",
    },

    {
      field: "converted_trips",
      headerName: "Converted Trips",
      width: (width / 12) * 2,
    },
    {
      field: "share",
      headerName: "Percentage",
      width: (width / 12) * 2,
    },
  ];

  const columns = [
    {
      field: "day",
      headerName: " Days to Cancel",
      width: (width / 12) * 3,
      cellClassName: "gridcell",
    },

    {
      field: "cancelled_trips",
      headerName: "Cancelled Trips",
      width: (width / 12) * 2,
    },
    {
      field: "share",
      headerName: "Percentage",
      width: (width / 12) * 2,
    },
  ];

  const columns15 = [
    {
      field: "source",
      headerName: "Source",
      width: (width / 12) ,
      cellClassName: "gridcell",
    },
     {
      field: "campaign",
      headerName: "Campaign",
      width: (width / 12) * 2,
    },

    {
      field: "ad_set",
      headerName: "Ad Set",
      width: (width / 12) * 2,
    },
    {
      field: "ad",
      headerName: "Ad",
      width: (width / 12) * 2,
    },
    {
      field: "lp_version",
      headerName: "LP Number",
      width: (width / 12) ,
    },
     {
      field: "version",
      headerName: "Version",
      width: (width / 12) ,
    },
     {
      field: "totalRecords",
      headerName: "Visits",
      width: (width / 12),
    },
     {
      field: "totalLeads",
      headerName: "Leads Placed",
      width: (width / 12),
    },
     {
      field: "conversionRate",
      headerName: "Conv %",
      width: (width / 12),
    },
  ];

  const columns3 = [
    {
      field: "day",
      headerName: " Days after Hot",
      width: (width / 12) * 3,
      cellClassName: "gridcell",
    },

    {
      field: "hot",
      headerName: "Total Hot",
      width: (width / 12) * 1,
    },
    {
      field: "hot_trips",
      headerName: "Still Hot",
      width: (width / 12) * 1,
    },
    {
      field: "conv",
      headerName: "Converted",
      width: (width / 12) * 1,
    },
    {
      field: "share",
      headerName: "Percentage",
      width: (width / 12) * 1,
    },
    {
      field: "bo",
      headerName: "BO",
      width: (width / 12) * 2,
    },
  ];
  const columns4 = [
    {
      field: "name",
      headerName: " Hotel Name",
      width: (width / 12) * 3,
      cellClassName: "gridcell",
    },

    {
      field: "quoted_rncount",
      headerName: "Quoted RN",
      width: (width / 12) * 2,
    },
    {
      field: "conv_rncount",
      headerName: "Converted RN",
      width: (width / 12) * 2,
    },
  ];

  const columns5 = [
    {
      field: "campaign",
      headerName: " Campaign Name",
      width: (width / 12) *2,
      cellClassName: "gridcell",
    },
    {
      field: "total",
      headerName: "Total Leads",
      width: (width / 12),
    },
    {
      field: "status4",
      headerName: "Best",
      width: (width / 12),
    },
    {
      field: "status3",
      headerName: "High",
      width: (width / 12),
    },
    {
      field: "status2",
      headerName: "Mid",
      width: (width / 12),
    },
    {
      field: "status1",
      headerName: "Low",
      width: (width / 12),
    },
    {
      field: "status4p",
      headerName: "Best %",
      width: (width / 12),
    },
    {
      field: "status3p",
      headerName: "High %",
      width: (width / 12),
    },
    {
      field: "status2p",
      headerName: "Mid %",
      width: (width / 12),
    },
    {
      field: "status1p",
      headerName: "Low %",
      width: (width / 12),
    },
    
  ];

  const columns6 = [
    {
      field: "status",
      headerName: " Status Name",
      width: (width / 12)*2,
      cellClassName: "gridcell",
    },
    {
      field: "count",
      headerName: "# Leads",
      width: (width / 12),
    },
    {
      field: "percentage",
      headerName: "% Leads",
      width: (width / 12),
    },
    {
      field: "pot",
      headerName: "Pot",
      width: (width / 12),
    },
    
    {
      field: "canc_lead",
      headerName: "Canc Leads",
      width: (width / 12),
    },
    
    {
      field: "work_done",
      headerName: "Work Done",
      width: (width / 12),
    },
    {
      field: "hot_lead",
      headerName: "Hot Leads",
      width: (width / 12),
    },
    {
      field: "hot_lead_per",
      headerName: "% Hot Leads",
      width: (width / 12),
    },
    {
      field: "conv_lead",
      headerName: "Conv Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "conv_lead_per",
      headerName: "% Conv Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "bo_lead",
      headerName: "BO Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "bo_lead_per",
      headerName: "% BO Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "active_lead",
      headerName: "Active Leads",
      width: (width / 12),
    },
    {
      field: "active_lead_per",
      headerName: "% Active Leads",
      width: (width / 12),
    },
    {
      field: "trip_created",
      headerName: "Trip Created",
      width: (width / 12),
    },
    {
      field: "trip_created_per",
      headerName: "Trip Created %",
      width: (width / 12),
    },
  ];

  const columns7 = [
    {
      field: "quote_id",
      headerName: " Quote Id",
      width: (width / 24),
      cellClassName: "gridcell",
    },
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 24),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12)*0.75,
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "adult",
      headerName: "Adult",
      width: (width / 12)*0.5,
    },
    {
      field: "child",
      headerName: "Child",
      width: (width / 12)*0.5,
    },
    {
      field: "duration",
      headerName: "Duration",
      width: (width / 12)*0.5,
    },
    {
      field: "flight_sp",
      headerName: "Flight Total",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_pp",
      headerName: "Flight PP",
      width: (width / 12)*0.75,
    },
    {
      field: "land_sp",
      headerName: "Land SP",
      width: (width / 12)*0.75,
    },
    {
      field: "land_pp",
      headerName: "Land PP",
      width: (width / 12)*0.75,
    },
    {
      field: "land_per_pax",
      headerName: "Land Per Pax",
      width: (width / 12)*0.75,
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12),
    },
    {
      field: "land_profit",
      headerName: "Land Profit",
      width: (width / 12),
    },
    {
      field: "land_profit_perc",
      headerName: "Land Profit %",
      width: (width / 12),
    },
    {
      field: "land_profit_perc_cost",
      headerName: "Land Profit cost basis%",
      width: (width / 12),
    },
    {
      field: "header",
      headerName: "Sample",
      width: (width / 12),
    },
    {
      field: "canc_reason",
      headerName: "Canc Reason",
      width: (width / 12),
    },
    {
      field: "conv_quote",
      headerName: "Conv Quote",
      width: (width / 12),
    },
    {
      field: "budget",
      headerName: "Budget",
      width: (width / 12),
    },
    {
      field: "type",
      headerName: "Type",
      width: (width / 12),
    },
    {
      field: "special",
      headerName: "Special",
      width: (width / 12),
    },
    {
      field: "edit_count",
      headerName: "Edit Count",
      width: (width / 12),
    },
    {
      field: "landcpperpp",
      headerName: "Land CP/PP",
      width: (width / 12),
    },
    
  ];

  const columns7b = [
    {
      field: "sp",
      headerName: "SP",
      width: (width / 12)*3,
      cellClassName: "gridcell",
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12)*2,
    },

    
  ];

  const columns7c = [
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12)*2,
      cellClassName: "gridcell",
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12)*1,
    },
     {
      field: "avg_land_pp",
      headerName: "Land PP",
      width: (width / 12)*1,
    },
    {
      field: "avg_flight_pp",
      headerName: "Flight PP",
      width: (width / 12)*1,
    },
    {
      field: "profit_perc",
      headerName: "Profit Perc",
      width: (width / 12)*1,
    },
    
  ];

  const columns8= [
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 12),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12),
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "pax",
      headerName: "Pax",
      width: (width / 12)*0.75,
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
      {
      field: "hot_at",
      headerName: "Hot At",
      width: (width / 12),
    },
    {
      field: "conv_date",
      headerName: "Time (H to C)",
      width: (width / 12),
    },   
    {
      field: "canc_time",
      headerName: "Time (C to C)",
      width: (width / 12),
    }, 
     {
      field: "hvb",
      headerName: "Hot Verified By",
      width: (width / 12),
    },
    {
      field: "previous_comment",
      headerName: "Previous Comment",
      width: (width / 12) *3,
    },
    {
      field: "last_comment",
      headerName: "Last Comment",
      width: (width / 12)*3,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: (width / 12),
    },
    {
      field: "email",
      headerName: "Email",
      width: (width / 12),
    },
  ];

  const columns8b= [
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 12),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12),
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
     {
      field: "hot_at",
      headerName: "Hot At",
      width: (width / 12),
    },
       {
      field: "hvb",
      headerName: "Hot Verified By",
      width: (width / 12),
    },
    {
      field: "previous_comment",
      headerName: "Previous Comment",
      width: (width / 12) *3,
    },
    {
      field: "last_comment",
      headerName: "Last Comment",
      width: (width / 12)*3,
    },
    {
      field: "super_hot",
      headerName: "Super Hot Date",
      width: (width / 12),
    },
  ];

  const columns9= [
    {
      field: "month",
      headerName: "Month",
      width: (width / 12)*2,
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12)*2,
    },
    {
      field: "count2",
      headerName: "Converted Count",
      width: (width / 12)*2,
    },
  ];

  const columns10 = [
    {
      field: "status",
      headerName: " Status Name",
      width: (width / 12)*2,
      cellClassName: "gridcell",
    },
    {
      field: "count",
      headerName: "# Trips",
      width: (width / 12)*0.75,
    },
    {
      field: "pot",
      headerName: "Pot",
      width: (width / 12)*0.75,
    },
    {
      field: "canc_lead",
      headerName: "Canc Leads",
      width: (width / 12),
    },
    
    {
      field: "days_to_cancel",
      headerName: "Cancel Days",
      width: (width / 12)*0.75,
    },
    {
      field: "days_to_convert",
      headerName: "Convert Days",
      width: (width / 12)*0.75,
    },
    {
      field: "hot_to_convert",
      headerName: "H2C Time",
      width: (width / 12)*0.75,
    },
    {
      field: "hot_lead",
      headerName: "Hot Leads",
      width: (width / 12),
    },
    {
      field: "hot_lead_per",
      headerName: "% Hot Leads",
      width: (width / 12),
    },
    {
      field: "conv_lead",
      headerName: "Conv Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "conv_lead_per",
      headerName: "% Conv Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "bo_lead",
      headerName: "BO Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "bo_lead_per",
      headerName: "% BO Leads",
      width: (width / 12)*0.75,
    },
    {
      field: "avg_profit",
      headerName: "Avg. Profit",
      width: (width / 12)*0.75,
    },
  ];

  const columns11 = [
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 24),
    },
    {
      field: "cust_name",
      headerName: "Cust Name",
      width: (width / 12),
    },
    {
      field: "owner",
      headerName: "Owner",
      width: (width / 12),
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12),
    },
    {
      field: "status",
      headerName: "Status",
      width: (width / 12),
    },
    {
      field: "comp_status",
      headerName: "Comp. Status",
      width: (width / 12)*2,
    },
    {
      field: "comp_from",
      headerName: "From",
      width: (width / 12)*2,
    },
  ];

  const headers2=[
    
    {label:"Trip Id", key:"trip_id"},
    {label:"Customer Name", key:"cust_name"},
    {label:"Trip Owner", key:"owner"},
    {label:"Destination", key:"destination"},
    {label:"Trip Status", key:"status"},
    {label:"Hot At", key:"hot_at"},
     {label:"Hot Verified By", key:"hvb"},
    {label:"Previous Comment", key:"previous_comment"},
    {label:"Last Comment", key:"last_comment"},
    {label:"Phone", key:"phone"},
    {label:"Email", key:"email"},
   
]

  const headers=[
    {label:"Quote Id", key:"quote_id"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Customer Name", key:"cust_name"},
    {label:"Trip Owner", key:"owner"},
    {label:"Destination", key:"destination"},
    {label:"Trip Status", key:"status"},
    {label:"Start Date", key:"start_date"},
    {label:"Adult", key:"adult"},
    {label:"Child", key:"child"},
    {label:"Duration", key:"duration"},
    {label:"Flight SP", key:"flight_sp"},
    {label:"FLight PP", key:"flight_pp"},
    {label:"Land SP", key:"land_sp"},
    {label:"Land PP", key:"land_pp"},
    {label:"Land Per Pax", key:"land_per_pax"},
    {label:"FLight Profit", key:"flight_profit"},
    {label:"Land Profit", key:"land_profit"},
    {label:"Land Profit %", key:"land_profit_perc"},
    {label:"Land Profit cost basis %", key:"land_profit_perc_cost"},
    {label:"Sample", key:"header"},
    {label:"Canc Reason", key:"canc_reason"},
    {label:"Conv Quote", key:"conv_quote"},
    {label:"RBQ Budget", key:"budget"},
    {label:"RBQ Type", key:"type"},
    {label:"RBQ Special", key:"special"},
    {label:"Edit Count", key:"edit_count"},
    {label:"Land Cost PP", key:"landcpperpp"},
]

  const classes = useStyles();
  const [filterData, setfilterData] = useState([{}]);
  const [searchData, setsearchData] = useState([{}]);
  const [searchData2, setsearchData2] = useState([{}]);
  const [searchData3, setsearchData3] = useState([{}]);
  const [searchData4, setsearchData4] = useState([{}]);
  const [searchData5, setsearchData5] = useState([{}]);
  const [searchData6, setsearchData6] = useState([{meta_sub_platform:""}]);
  const [searchData7, setsearchData7] = useState([{}]);
  const [searchData17, setsearchData17] = useState([{}]);
  const [searchData8, setsearchData8] = useState([{}]);
  const [searchData9, setsearchData9] = useState([{}]);
  const [searchData10, setsearchData10] = useState([{}]);
  const [searchData11, setsearchData11] = useState([{}]);
  const [tlsplist, settlsplist] = useState([]);
  const [searchbyqe, setsearchbyqe] = useState(false);
  const [searchbysh, setsearchbysh] = useState(false);
  const [cohort, setcohort] = useState([]);
  const [cohort2, setcohort2] = useState([]);
  const [cohort3, setcohort3] = useState([]);
  const [cohort4, setcohort4] = useState([]);
  const [triplistfromleadlist, settriplistfromleadlist] = useState([]);
  const [listtripData, setlisttripData] = useState([]);
  const [listconvtripData, setlistconvtripData] = useState([]);
  const [listconvtripData2, setlistconvtripData2] = useState([]);
  const [listhottripData, setlisthottripData] = useState([]);
  const [listtripData2, setlisttripData2] = useState([]);
  const [listcomptripData, setlistcomptripData] = useState([]);
  const [listhottripData2, setlisthottripData2] = useState([]);
  const [listhottripData20, setlisthottripData20] = useState([]);
  const [listhottripData3, setlisthottripData3] = useState([]);
  const [listpottripData, setlistpottripData] = useState([]);
  const [listcanctripData, setlistcanctripData] = useState([]);
  const [listbotripData, setlistbotripData] = useState([]);
  const [listactivetripData, setlistactivetripData] = useState([]);
  const [listquoteData, setlistquotepData] = useState([]);
  const [listquoteData2, setlistquoteData2] = useState([]);
  const [listquoteData3, setlistquoteData3] = useState([]);
  const [listleadData, setlistleadData] = useState([]);
  var [listleadData2, setlistleadData2] = useState([]);
  var [lpset, setlpset] = useState([]);
  var { cuser, role } = GetRole();
  const [emp, setemp] = useState([]);
  const [dest, setdest] = useState([]);
  var frperc=0, frq=0
  var titaniumcount=0, totalcanc=0, hqleads=0, hqtrips=0, nrcanc=[]
  const headers3=[
    {label:"Month", key:"month"},
    {label:"Count", key:"count"},
  ]

  const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    let sortedemp = empshortname.sort()
    const result=groupBy(empsplist, v=>v.reporting_manager)
    console.log(result)
    var tllist=[]
    for (const [key, value] of result) {
      var temp={
        tl:key,
        sp:value.map(v=>v.short_name)
      }
      tllist=[...tllist, temp]
    }
    settlsplist(tllist)
    setemp(sortedemp);
  }catch(err){
    console.log(err)
  }
  };

  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  }

  useEffect(() => {
    getEmployees();
    getDest()
  }, []);

  var analytics = [];
  var analytics2 = [];
  var analytics3 = [];
  var analytics4 = [];
  var medcanc = 0,
    medconv = 0,
    medhot = 0,
    avgcanc = 0,
    avgconv = 0,
    avghot = 0;

  const handleconvSearch = async (e) => {
    try{
      if(cuser!=="Debayan" && ((new Date(searchData6.end_date).getTime()-new Date(searchData6.start_date).getTime())/(1000*60*60*24))>93){
      alert("Do not search for data exceeding 93 days")
    }else{

    
    if (searchData2.start_date && searchData2.end_date) {
      const data = await searchconvTripsbyDate(
        searchData2.start_date,
        searchData2.end_date
      );

      const finarray=removeDuplicates(data.data, "trip_id")
      setlistconvtripData(finarray);

      console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
  }catch(err){
    console.log(err)
  }
  };

  const handlehotSearch = async (e) => {
    try{
      if(cuser!=="Debayan" && ((new Date(searchData6.end_date).getTime()-new Date(searchData6.start_date).getTime())/(1000*60*60*24))>93){
        alert("Do not search for data exceeding 93 days")
      }else{
    if (searchData3.start_date && searchData3.end_date) {
      const data = await searchhotTripsbyDate(
        searchData3.start_date,
        searchData3.end_date
      );
      const unique=removeDuplicates(data.data, "trip_id")
      setlisthottripData(unique);

      console.log(unique)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
  }catch(err){
    console.log(err)
  }
  };

  const handlehotSearch2 = async (e) => {
    try{
    if(searchbysh){
      if (searchData9.start_date && searchData9.end_date) {
        const data = await searchsuperhotTripsbyDate(
          searchData9.start_date,
          searchData9.end_date
        );
        const finarray=removeDuplicates(data.data, "trip_id")
        setlisthottripData3(finarray);
  
        //console.log(data.data)
      } else {
        alert(
          "Please enter all parameters -start date and end date before search"
        );
      }
    }else{
    if (searchData9.start_date && searchData9.end_date) {
      const data = await searchhotTripsbyDate(
        searchData9.start_date,
        searchData9.end_date
      );
      
      const finarray=removeDuplicates(data.data, "trip_id")
      //console.log(data.data)
      setlisthottripData3(finarray);
      const temp=finarray.map(t=>Number(t.trip_id))
      console.log(finarray)
      const data2=await fetchconvdate(temp)
      //console.log(data2.data)
      setlisthottripData20(data2.data)
      // const data2=data.data.filter(t=>t.status_history.new_status=="Converted")
      
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
  }catch(err){
    console.log(err)
  }
  };

  const handlehotelSearch = async (e) => {
    try{
    // console.log(searchData2)
    if (searchData4.start_date && searchData4.end_date && searchData4.destination) {
      const data = await searchQuotesbyDate(
        searchData4.start_date,
        searchData4.end_date,
        searchData4.destination
      );
      setlistquotepData(data.data);

      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -destination, start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handlecancSearch = async (e) => {
    try{
    if (searchData.start_date && searchData.end_date) {
      //console.log(searchData)
      const data = await searchcancTripsbyDate(
        searchData.start_date,
        searchData.end_date
      );
      //console.log(data.data)
      const finarray=removeDuplicates(data.data, "trip_id")
      //console.log(finarray)
      setlistcanctripData(finarray);

     
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  const handlecampaignSearch = async (e) => {
    try{
    if (searchData5.start_date && searchData5.end_date) {
      // console.log(searchData)
      const data = await searchLeadsbyDate(
        searchData5.start_date,
        searchData5.end_date
      );
      setlistleadData(data.data.filter(lead => lead.lead_campaign));

      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  function DateCalc3 (date, diff) {
    var fupsomeDate = new Date(date);
    //console.log(fupsomeDate)
    fupsomeDate.setDate(fupsomeDate.getDate() + diff);
    const fupy = fupsomeDate.getFullYear();
    const fupm =
      fupsomeDate.getMonth() + 1 < 10
        ? "0" + (fupsomeDate.getMonth() + 1)
        : fupsomeDate.getMonth() + 1;
    const fupdt =
      fupsomeDate.getDate() < 10
        ? "0" + fupsomeDate.getDate()
        : fupsomeDate.getDate();
    const fupfinalDate = fupy + "-" + fupm + "-" + fupdt;
    //console.log(fupfinalDate)
    return fupfinalDate;
  }

  const handlestatusSearch = async (e) => {
    try{
      if(cuser!=="Debayan" && ((new Date(searchData6.end_date).getTime()-new Date(searchData6.start_date).getTime())/(1000*60*60*24))>93){
        alert("Do not search for data exceeding 93 days")
      }else{
    if (searchData6.start_date && searchData6.end_date) {
      const cutoffdate=DateCalc3(searchData6.end_date,60)
      //console.log(searchData6.end_date, cutoffdate)
      const data = await searchLeadsbyDate3(
        searchData6.start_date,
        searchData6.end_date
      );
      setlistleadData2(data.data)

      const leadidlist=data.data.map(l=>l.lead_id)
      const data6=await  gettripfromleadidlist(leadidlist)
      settriplistfromleadlist(data6.data)
      

      //console.log(data6.data)
      const data2 = await searchhotTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      const temp3=removeDuplicates(data2.data, "trip_id")
      console.log(data2.data)
      setlisthottripData2(temp3.filter(trip => trip.lead));
      const data3 = await searchconvTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      const temp4=removeDuplicates(data3.data, "trip_id")
      console.log(data3.data)
      setlistconvtripData2(temp4.filter(trip => trip.lead))
      const data4 = await searchboTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      const temp5=removeDuplicates(data4.data, "trip_id")
      //console.log(temp5.filter(trip => trip.lead))
      setlistbotripData(temp5.filter(trip => trip.lead))
      console.log(data4.data)
      const data5 = await searchActiveTripsbyDate(
        searchData6.start_date,
        cutoffdate
      );
      const temp6=removeDuplicates(data5.data, "trip_id")
      //console.log(temp6.filter(trip => trip.lead))
      setlistactivetripData(temp6.filter(trip => trip.lead));
      console.log(data5.data)
      //statuscalc()
      
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
  }catch(err){
    console.log(err)
  }
  };

  const handlestatusSearch2 = async (e) => {
    try{
      if(cuser!=="Debayan" && ((new Date(searchData6.end_date).getTime()-new Date(searchData6.start_date).getTime())/(1000*60*60*24))>93){
        alert("Do not search for data exceeding 93 days")
      }else{
    if (searchData6.start_date && searchData6.end_date) {
      const cutoffdate=DateCalc3(searchData6.end_date,60)
      console.log(searchData6.end_date, cutoffdate)
      const data = await searchTripsbyDate2(
        searchData6.start_date,
        searchData6.end_date
      );
      setlisttripData2(data.data);
      // const data = await searchcancTripsbyDate(
      //   searchData6.start_date,
      //   searchData6.end_date
      // );
      // const temp=data.data.filter(t=>t.canc_reason=="No Response")
      // setlisttripData2(temp);
      // console.log(data.data)
      const data2 = await searchhotTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      const hottemp=removeDuplicates(data2.data, "trip_id")
      setlisthottripData2(hottemp.filter(trip => trip.lead));
      const data3 = await searchconvTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      const convtemp=removeDuplicates(data3.data, "trip_id")
      console.log(data3.data)
      setlistconvtripData2(convtemp.filter(trip => trip.lead));
      const data4 = await searchboTripsbyDate2(
        searchData6.start_date,
        cutoffdate
      );
      setlistbotripData(data4.data.filter(trip => trip.lead));
      console.log(data4.data)
      const data5 = await searchActiveTripsbyDate(
        searchData6.start_date,
        cutoffdate
      );
      setlistbotripData(data5.data.filter(trip => trip.lead));
      console.log(data5.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
  }catch(err){
    console.log(err)
  }
  };



  const handlequoteSearch = async (e) => {
    try{
    if(searchbyqe){
      const today=DateCalc(0)
      if (searchData7.start_date && searchData7.end_date) {
        // const data = await searchQEbyDate(
        //   searchData7.start_date,
        //   searchData7.end_date
        // );
        const data = await newsearchQEbyDate(
          searchData7.start_date,
          searchData7.end_date
        );
        console.log(data.data)
       const filtered = filterQuotes(data.data);
        console.log(filtered);
  
        setlistquoteData2(filtered);
      } else {
        alert(
          "Please enter all parameters -start date and end date before search"
        );
      }
    } else{
    if (searchData7.start_date && searchData7.end_date) {
      const data = await searchQCbyDate(
        searchData7.start_date,
        searchData7.end_date
      );
      const data2 = await newsearchQEbyDate(
        searchData7.start_date,
        searchData7.end_date
      );
      const filtered = filterQuotes(data2.data);
        console.log(filtered);
      const result = data.data.filter(item1 => 
        !filtered.some(item2 => item2.quote_id === item1.quote_id)
      );
      setlistquoteData2(result);
      // const Ind=data.data.filter(q=>q.primary_destination=="Bali")
      //console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -start date and end date before search"
      );
    }
  }
}catch(err){
  console.log(err)
}
  };

  const handletripSearch = async (e) => {
    try{
      var quotelist=[]
      if (searchData8.start_date && searchData8.end_date) {
        // const data = await  searchcancTripsbyDate(
        //    searchData8.start_date,
        //    searchData8.end_date
        //   //"2023-06-20", "2023-06-26"
        // );
        const data = await  searchConvTripsbyStartDate(
          searchData8.start_date,
          searchData8.end_date
         //"2023-06-20", "2023-06-26"
       );
        const data3=data.data.filter(trip=>trip.primary_destination=="Indonesia")
        //const data3=data.data
        setlisttripData(data3);
        //console.log(data3)
        if(data3.length>0){
        const triplist=data3.map(trip=>"trip_id" in trip?trip.trip_id:1)
        //console.log(triplist)
        const quotelist2=data3.map(trip=>"quote" in trip && trip.quote.length>0?trip.quote:[])
        //console.log(quotelist2)
        for(let i=0;i<quotelist2.length;i++) {
          for(let j=0;j<quotelist2[i].length;j++) {
            quotelist.push(quotelist2[i][j])
          }
        }
        //console.log(quotelist)
        if(triplist.length>0){
          const data2 = await  fetchquotefromtrip(quotelist);
          setlistquoteData3(data2.data.filter(quote=>"quote_price" in quote && "cost_price" in quote))
          console.log(data2.data)
        }
      }else{
        alert("No Trips Found")
      }
      } else {
        alert(
          "Please enter all parameters -start date and end date before search"
        );
      }
    }catch(err){
      console.log(err)
    }
  };

  const handlepotSearch = async (e) => {
    try{
    // console.log(searchData2)
    if (searchData10.start_date && searchData10.end_date) {
      const data = await searchpotentialTripsbyDate(
        searchData10.start_date,
        searchData10.end_date,
      );
      setlistpottripData(data.data);

      console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -destination, start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

    const handlecompSearch = async (e) => {
    try{
    // console.log(searchData2)
    if (searchData11.start_date && searchData11.end_date) {
      const data = await fetchTripsbyCompetitionDate(
        searchData11.start_date,
        searchData11.end_date,
      );
      setlistcomptripData(data.data);

      console.log(data.data)
    } else {
      alert(
        "Please enter all parameters -destination, start date and end date before search"
      );
    }
  }catch(err){
    console.log(err)
  }
  };

  // Day to convert calculation
  if (listconvtripData.length > 0) {
    var status_history = {};
    var rightentry = {};
    var finalarray = [];
    for (let i = 0; i < listconvtripData.length; i++) {
      if (listconvtripData[i]?.status_history) {
        status_history = listconvtripData[i].status_history;
        // console.log(status_history)
        // const status = status_history.filter(
        //   (status) => status.new_status == "Converted"
        // );
        // if (status.length) {
        //   rightentry = status[status.length - 1];
        // } else {
        //   rightentry = 0;
        // }
        // console.log(new Date(listconvtripData[i].createdAt))
        // console.log(new Date(rightentry.date))
        finalarray.push(
          Math.round(
            (new Date(status_history.date).getTime() -
              new Date(listconvtripData[i].createdAt).getTime()) /
              (1000 * 60 * 60 * 24)
          )
        );
        medconv = Median(finalarray);
        avgconv =
          Math.round(
            (finalarray.reduce((a, b) => a + b, 0) * 100) / finalarray.length
          ) / 100;
      }
    }
    //console.log(finalarray)
    var g1 = 0,
      g2 = 0,
      g3 = 0,
      g4 = 0,
      g5 = 0;
    for (let i = 0; i <= finalarray.length; i++) {
      if (finalarray[i] <= 3) {
        g1++;
      } else if (finalarray[i] > 3 && finalarray[i] <= 7) {
        g2++;
      } else if (finalarray[i] > 7 && finalarray[i] <= 14) {
        g3++;
      } else if (finalarray[i] > 14 && finalarray[i] <= 28) {
        g4++;
      } else if (finalarray[i] > 28) {
        g5++;
      }
    }
    //console.log(g1,g2,g3,g4,g5)
    var total = g1 + g2 + g3 + g4 + g5;
    analytics2 = [
      {
        day: "Less than or equal to 3",
        value: g1,
        share: Math.round((g1 / total) * 100),
      },
      {
        day: "Between 4 and 7",
        value: g2,
        share: Math.round((g2 / total) * 100),
      },
      {
        day: "Between 8 and 14",
        value: g3,
        share: Math.round((g3 / total) * 100),
      },
      {
        day: "Between 15 and 28",
        value: g4,
        share: Math.round((g4 / total) * 100),
      },
      {
        day: "Greater than 28",
        value: g5,
        share: Math.round((g5 / total) * 100),
      },
      {
        day: "Total",
        value: total,
        share: Math.round((total / total) * 100),
      },
    ];
  }

  //Days to cancel calculation
  if (listcanctripData.length > 0) {
    var status_history2 = {};
    var rightentry2 = {};
    var finalarray2 = [];
    for (let i = 0; i < listcanctripData.length; i++) {
      //console.log(listcanctripData[i])
      if (listcanctripData[i] && "status_history" in listcanctripData[i] && "date" in listcanctripData[i].status_history) {
        status_history2 = listcanctripData[i].status_history;
        // console.log(status_history)
        // const status = status_history2.filter(
        //   (status) =>
        //     status.new_status == "Cancelled" ||
        //     status.new_status == "Booked Outside"
        // );
        // if (status.length) {
        //   rightentry2 = status[status.length - 1];
        // } else {
        //   rightentry2 = 0;
        // }
        // console.log(new Date(listconvtripData[i].createdAt))
        // if (!(Math.round((new Date(rightentry2.date)-new Date(listcanctripData[i].createdAt))/(1000*60*60*24)))){
        //   console.log(listcanctripData[i])
        // }

        finalarray2.push(
          Math.round(
            (new Date(status_history2.date).getTime() -
              new Date(listcanctripData[i].createdAt).getTime()) /
              (1000 * 60 * 60 * 24)
          )
        );
        console.log(finalarray2)

        medcanc = Median(finalarray2);
        avgcanc =
          Math.round(
            (finalarray2.reduce((a, b) => a + b, 0) * 100) / finalarray2.length
          ) / 100;
      }
    }
    //console.log(finalarray)
    var cg1 = 0,
      cg2 = 0,
      cg3 = 0,
      cg4 = 0,
      cg5 = 0;
    for (let i = 0; i <= finalarray2.length; i++) {
      if (finalarray2[i] <= 3) {
        cg1++;
      } else if (finalarray2[i] > 3 && finalarray2[i] <= 7) {
        cg2++;
      } else if (finalarray2[i] > 7 && finalarray2[i] <= 14) {
        cg3++;
      } else if (finalarray2[i] > 14 && finalarray2[i] <= 28) {
        cg4++;
      } else if (finalarray2[i] > 28) {
        cg5++;
      }
    }
    //console.log(g1,g2,g3,g4,g5)
    var ctotal = cg1 + cg2 + cg3 + cg4 + cg5;
    analytics = [
      {
        day: "Less than or equal to 3",
        value: cg1,
        share: Math.round((cg1 / ctotal) * 100),
      },
      {
        day: "Between 4 and 7",
        value: cg2,
        share: Math.round((cg2 / ctotal) * 100),
      },
      {
        day: "Between 8 and 14",
        value: cg3,
        share: Math.round((cg3 / ctotal) * 100),
      },
      {
        day: "Between 15 and 28",
        value: cg4,
        share: Math.round((cg4 / ctotal) * 100),
      },
      {
        day: "Greater than 28",
        value: cg5,
        share: Math.round((cg5 / ctotal) * 100),
      },
      {
        day: "Total",
        value: ctotal,
        share: Math.round((ctotal / ctotal) * 100),
      },
    ];
  }

  //Days to hot calculation
  //still hot calculation
  var newhotlist=[]
if(searchData3.trip_channel && searchData3.trip_channel !=="All"){
  //console.log(newhotlist)
  newhotlist=listhottripData.filter(trip => trip.trip_channel==searchData3.trip_channel)
  //console.log(newhotlist)
}else{
  newhotlist=listhottripData
}

if(searchData3.destination){
  //console.log(newhotlist)
  newhotlist=newhotlist.filter(trip => trip.primary_destination==searchData3.destination)
  //console.log(newhotlist)
}

if(searchData3.trip_owner){
  newhotlist=newhotlist.filter(trip => trip.trip_owner==searchData3.trip_owner)
 
}

  if (newhotlist.length > 0) {
    var status_history3 = [];
    var rightentry3 = {};
    var finalarray3 = [];
    for (let i = 0; i <= newhotlist.length; i++) {

    
      if (
        newhotlist[i]?.status_history &&
        newhotlist[i]?.trip_status == "Hot" 
        //newhotlist[i].trip_owner == searchData3.trip_owner
      ) {
        status_history3 = newhotlist[i].status_history;

        
        // console.log(status_history)
        // const status = status_history3.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status_history3) {
        //   rightentry3 = status[status.length - 1];
        // } else {
        //   rightentry3 = 0;
        // }

        finalarray3.push(
          Math.round(
            (new Date() - new Date(status_history3.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)

        medhot = Median(finalarray3);
        avghot =
          Math.round(
            (finalarray3.reduce((a, b) => a + b, 0) * 100) / finalarray3.length
          ) / 100;
      }
    }
    //console.log(finalarray3)
    var hg1 = 0,
      hg2 = 0,
      hg3 = 0,
      hg4 = 0,
      hg5 = 0;
    for (let i = 0; i <= finalarray3.length; i++) {
      if (finalarray3[i] <= 3) {
        hg1++;
      } else if (finalarray3[i] > 3 && finalarray3[i] <= 7) {
        hg2++;
      } else if (finalarray3[i] > 7 && finalarray3[i] <= 10) {
        hg3++;
      } else if (finalarray3[i] > 10 && finalarray3[i] <= 14) {
        hg4++;
      } else if (finalarray3[i] > 14) {
        hg5++;
      }
    }
//--------------------------------------------------------------------------------total hot calculation
    var status_history32 = [];
    var rightentry32 = {};
    var finalarray32 = [];
    for (let i = 0; i <= newhotlist.length; i++) {
      if (
        newhotlist[i]?.status_history 
        //newhotlist[i].trip_owner == searchData3.trip_owner
      ) {
        status_history32 = newhotlist[i].status_history;
        // console.log(status_history)
        // const status = status_history32.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status.length) {
        //   rightentry32 = status[status.length - 1];
        // } else {
        //   rightentry32 = 0;
        // }

        finalarray32.push(
          Math.round(
            (new Date() - new Date(status_history32.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)
      }
    }
    //console.log(finalarray3)
    var hcg1 = 0,
      hcg2 = 0,
      hcg3 = 0,
      hcg4 = 0,
      hcg5 = 0;
    for (let i = 0; i <= finalarray32.length; i++) {
      if (finalarray32[i] <= 3) {
        hcg1++;
      } else if (finalarray32[i] > 3 && finalarray32[i] <= 7) {
        hcg2++;
      } else if (finalarray32[i] > 7 && finalarray32[i] <= 10) {
        hcg3++;
      } else if (finalarray32[i] > 10 && finalarray32[i] <= 14) {
        hcg4++;
      } else if (finalarray32[i] > 14) {
        hcg5++;
      }
    }

    //--------------------------------------------------------------------------------converted_trips calculation
    var status_history33 = [];
    var rightentry33 = {};
    var finalarray33 = [];
    if(searchData3.trip_owner !==""){

    
    for (let i = 0; i <= newhotlist.length; i++) {
      if (
        newhotlist[i]?.status_history &&
        (newhotlist[i].trip_status == "Converted" ||
          newhotlist[i].trip_status == "Closed") &&
        newhotlist[i].trip_owner == searchData3.trip_owner
      ) {
        status_history33 = newhotlist[i].status_history;
        // console.log(status_history)
        // const status = status_history33.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status.length) {
        //   rightentry33 = status[status.length - 1];
        // } else {
        //   rightentry33 = 0;
        // }

        finalarray33.push(
          Math.round(
            (new Date() - new Date(status_history33.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)
      }
    }
  }else{
    for (let i = 0; i <= newhotlist.length; i++) {
      if (
        newhotlist[i]?.status_history &&
        (newhotlist[i].trip_status == "Converted" ||
          newhotlist[i].trip_status == "Closed") 
      ) {
        status_history33 = newhotlist[i].status_history;
        // console.log(status_history)
        // const status = status_history33.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status.length) {
        //   rightentry33 = status[status.length - 1];
        // } else {
        //   rightentry33 = 0;
        // }

        finalarray33.push(
          Math.round(
            (new Date() - new Date(status_history33.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)
      }
    }
  }
    //console.log(finalarray3)
    var hcgt1 = 0,
      hcgt2 = 0,
      hcgt3 = 0,
      hcgt4 = 0,
      hcgt5 = 0;
    for (let i = 0; i <= finalarray33.length; i++) {
      if (finalarray33[i] <= 3) {
        hcgt1++;
      } else if (finalarray33[i] > 3 && finalarray33[i] <= 7) {
        hcgt2++;
      } else if (finalarray33[i] > 7 && finalarray33[i] <= 10) {
        hcgt3++;
      } else if (finalarray33[i] > 10 && finalarray33[i] <= 14) {
        hcgt4++;
      } else if (finalarray33[i] > 14) {
        hcgt5++;
      }
    }
    //console.log(g1,g2,g3,g4,g5)

 //--------------------------------------------------------------------------------bo calculation

    var status_history34 = [];
    var rightentry34 = {};
    var finalarray34 = [];
    if(searchData3.trip_owner !==""){
  
    
    for (let i = 0; i <= newhotlist.length; i++) {
      if (
        newhotlist[i]?.status_history &&
        (newhotlist[i].trip_status == "Booked Outside") &&
        newhotlist[i].trip_owner == searchData3.trip_owner
      ) {
        status_history34 = newhotlist[i].status_history;
        // console.log(status_history)
        // const status = status_history34.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status.length) {
        //   rightentry34 = status[status.length - 1];
        // } else {
        //   rightentry34 = 0;
        // }
  
        finalarray34.push(
          Math.round(
            (new Date() - new Date(status_history34.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)
      }
    }
  }else{
    for (let i = 0; i <= newhotlist.length; i++) {
      if (
        newhotlist[i]?.status_history &&
        (newhotlist[i].trip_status == "Booked Outside" ) 
      ) {
        status_history34 = newhotlist[i].status_history;
        // console.log(status_history)
        // const status = status_history34.filter(
        //   (status) => status.new_status == "Hot"
        // );
        // if (status.length) {
        //   rightentry34 = status[status.length - 1];
        // } else {
        //   rightentry34 = 0;
        // }
  
        finalarray34.push(
          Math.round(
            (new Date() - new Date(status_history34.date)) / (1000 * 60 * 60 * 24)
          )
        );
        //console.log(finalarray2)
      }
    }
  }
    //console.log(newhotlist.map(trip=>trip.trip_status))
    var hcgt11 = 0,
      hcgt12 = 0,
      hcgt13 = 0,
      hcgt14 = 0,
      hcgt15 = 0;
    for (let i = 0; i <= finalarray34.length; i++) {
      if (finalarray34[i] <= 3) {
        hcgt11++;
      } else if (finalarray34[i] > 3 && finalarray34[i] <= 7) {
        hcgt12++;
      } else if (finalarray34[i] > 7 && finalarray34[i] <= 10) {
        hcgt13++;
      } else if (finalarray34[i] > 10 && finalarray34[i] <= 14) {
        hcgt14++;
      } else if (finalarray34[i] > 14) {
        hcgt15++;
      }
    }

    var htotal = hg1 + hg2 + hg3 + hg4 + hg5;
  var hctotal = hcg1 + hcg2 + hcg3 + hcg4 + hcg5;
  var hcttotal = hcgt1 + hcgt2 + hcgt3 + hcgt4 + hcgt5;
  var hbototal = hcgt11 + hcgt12 + hcgt13 + hcgt14 + hcgt15;
  analytics3 = [
    {
      day: "Less than or equal to 3",
      value: hg1,
      hot: hcg1,
      conv: hcgt1,
      bo:hcgt11,
      share: Math.round((hg1 / htotal) * 100),
    },
    {
      day: "Between 4 and 7",
      value: hg2,
      hot: hcg2,
      conv: hcgt2,
      bo:hcgt12,
      share: Math.round((hg2 / htotal) * 100),
    },
    {
      day: "Between 8 and 10",
      value: hg3,
      hot: hcg3,
      conv: hcgt3,
      bo:hcgt13,
      share: Math.round((hg3 / htotal) * 100),
    },
    {
      day: "Between 11 and 14",
      value: hg4,
      hot: hcg4,
      conv: hcgt4,
      bo:hcgt14,
      share: Math.round((hg4 / htotal) * 100),
    },
    {
      day: "Greater than 14",
      value: hg5,
      hot: hcg5,
      conv: hcgt5,
      bo:hcgt15,
      share: Math.round((hg5 / htotal) * 100),
    },
    {
      day: "Total",
      value: htotal,
      hot: hctotal,
      conv: hcttotal,
      bo:hbototal,
      share: Math.round((htotal / htotal) * 100),
    },
  ];
  }

  //console.log(newhotlist)

  //-----------------------------------------------------------------------------------hoteldata creation
  const hotellist=[]
  for(let i=0; i<listquoteData.length; i++){
    const daydata=listquoteData[i].day
    for(let j=0; j<daydata.length; j++) {
      hotellist.push(daydata[j].hotel_name);
    }
  }

  //console.log(hotellist)
  const count = {};

  hotellist.forEach(element => {
  count[element] = (count[element] || 0) + 1;
});

  //console.log(count)
  const splitKeyValue = obj => {
    const keys = Object.keys(obj);
    const res = [];
    for(let i = 0; i < keys.length; i++){
       res.push({
          'name': keys[i],
          'count': obj[keys[i]]
       });
    };
    return res;
 };
 function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
       const key = keyGetter(item);
       const collection = map.get(key);
       if (!collection) {
           map.set(key, [item]);
       } else {
           collection.push(item);
       }
  });
  return map;
}
const getSumByKey = (arr, key) => {
  return arr.reduce(
    (accumulator, current) => accumulator + Number(current[key]),
    0
  );
};

 analytics4=splitKeyValue(count)

 var hotellist2=[]
 const convquotelist=listquoteData.filter(quote => quote.trip_status && (quote.trip_status=="Converted" || quote.trip_status=="Closed" ))
  for(let i=0; i<convquotelist.length; i++){
    const daydata2=convquotelist[i].day
    for(let j=0; j<daydata2.length; j++) {
      hotellist2.push(daydata2[j].hotel_name);
    }
  }
  const count2 = {};

  hotellist2.forEach(element => {
  count2[element] = (count2[element] || 0) + 1;
});
const analytics42=splitKeyValue(count2)
//check the code below to merge quoted rn and conv rn
// const combinedItems = (arr = []) => {
//   const res = arr.reduce((acc, obj) => {
//      let found = false;
//      for (let i = 0; i < acc.length; i++) {
//         if (acc[i].id === obj.id) {
//            found = true;
//            acc[i].count++;
//         };
//      }
//      if (!found) {
//         obj.count = 1;
//         acc.push(obj);
//      }
//      return acc;
//   }, []);
//   return res;
// }
 //console.log(analytics4)

 //testing TripCrafters
 const TestTClead = async () => {

    // console.log(searchData)
    const data = await TestTC({
      name:"abc",
      job:"mechanic"
    })
    
};

const getcancreason = (tripid) => {
  const data=listtripData.filter(t=>t.trip_id==tripid)
  //console.log(data[0].trip_owner)
  //const temp=data[0].trip_owner
  return data.length>0 && "trip_canc_reason_short" in data[0]?data[0].trip_canc_reason_short:""
}

const getconvquote=(tripid) => {
  const data=listtripData.filter(t=>t.trip_id==tripid)
  //console.log(data[0].trip_owner)
  //const temp=data[0].trip_owner
  return data.length>0 && "conv_quote" in data[0]?data[0].conv_quote:""
}

const gettimetoconvert=(trip)=>{
  const temp=listhottripData20.filter(t=>t.trip_id==trip.trip_id)
  if(temp.length>0){
    const temp3=temp[0].status_history.filter(sh=>sh.new_status=="Converted")
    if(temp3.length>0){
      const temp4=temp3[temp3.length-1].date
      const temp2=listhottripData3.filter(t=>t.trip_id==trip.trip_id && trip.status_history.new_status=="Hot")
      if(temp4 && temp2.length>0){
        
        const temp5=((new Date(temp4).getTime()-new Date(temp2[0].status_history.date).getTime())/(1000*60*60)).toFixed(1)
        if(temp5<0){
          return "0"
        }else{
          return temp5
        }
    }
    }else{
      return ""
    }
  // if(trip.trip_id==110878){
  //   console.log(data.data)
  //   console.log(temp2[0])
  // }
  // if(temp.length>0 && temp2.length>0){
  //   return ((new Date(temp[0].status_history.new_date).getTime()-new Date(temp2[0].status_history.new_date).getTime())/(1000*60*60)).toFixed(1)
  }else{
    
  }
}

const gettimefromcancel=(trip)=>{
  const temp=listhottripData20.filter(t=>t.trip_id==trip.trip_id)
  if(temp.length>0){
    const temp3=temp[0].status_history.filter(sh=>sh.new_status=="Converted")
    if(temp3.length>0){
      const temp4=temp3[temp3.length-1].date
      const temp2=temp[0].status_history.filter(sh=>sh.new_status=="Cancelled")
      if(temp4 && temp2.length>0){
        
        const temp5=((new Date(temp4).getTime()-new Date(temp2[temp2.length-1].date).getTime())/(1000*60*60)).toFixed(1)
        if(temp5<0){
          return "0"
        }else{
          return temp5
        }
    }
    }else{
      return ""
    }
  // if(trip.trip_id==110878){
  //   console.log(data.data)
  //   console.log(temp2[0])
  // }
  // if(temp.length>0 && temp2.length>0){
  //   return ((new Date(temp[0].status_history.new_date).getTime()-new Date(temp2[0].status_history.new_date).getTime())/(1000*60*60)).toFixed(1)
  }else{
    
  }
}

const gettl=(owner)=>{
  var temp=tlsplist.filter(t=>t.sp.includes(owner))
  if(temp.length>0){
return temp[0].tl
  }else{
return ""
  }
  
}

 //campign wise lead quality
 var resultarr3=[]
  if(listleadData.length > 0){
    let resultobject={}
    var resultarr2=[]
    var resultobject2=[]
    var resultobject3=[]
    var resultarr=[]
   
    const result2=groupBy(listleadData, v=>v.lead_campaign)
    for (let [key, value] of result2) {
      resultobject[key]=value
      resultobject3.push(key)
      resultobject2.push(resultobject[key])
      }
      //console.log(resultobject2)
      //console.log(resultobject3)
      
  for(let i=0; i<resultobject2.length; i++) {
    const result3=groupBy(resultobject2[i], v=>v.lead_status)
    var resultobject4={}
    var resultobject5={}
    for (let [key, value] of result3) {
       resultobject4[key]=value.length
       resultobject5[key]=Math.round(value.length/resultobject2[i].length*100)
    }
    resultarr.push(resultobject4)
    resultarr2.push(resultobject5)
  }

  for(let i=0; i<resultobject3.length; i++) {
    const tempobj={
      name: resultobject3[i],
      status1:resultarr[i]['Looking for information only. Will plan later']?resultarr[i]['Looking for information only. Will plan later']:0,
      status2:resultarr[i]['Thinking about going on a trip but nothing has been decided yet']?resultarr[i]['Thinking about going on a trip but nothing has been decided yet']:0,
      status3:resultarr[i]['Definitely going on a trip. Planning in progress']?resultarr[i]['Definitely going on a trip. Planning in progress']:0,
      status4:resultarr[i]['Travel date, destination and people travelling all finalized. Just looking for a package']?resultarr[i]['Travel date, destination and people travelling all finalized. Just looking for a package']:0,
      status1p:resultarr2[i]['Looking for information only. Will plan later']?resultarr2[i]['Looking for information only. Will plan later']:0,
      status2p:resultarr2[i]['Thinking about going on a trip but nothing has been decided yet']?resultarr2[i]['Thinking about going on a trip but nothing has been decided yet']:0,
      status3p:resultarr2[i]['Definitely going on a trip. Planning in progress']?resultarr2[i]['Definitely going on a trip. Planning in progress']:0,
      status4p:resultarr2[i]['Travel date, destination and people travelling all finalized. Just looking for a package']?resultarr2[i]['Travel date, destination and people travelling all finalized. Just looking for a package']:0,
      total:resultobject2[i].length,
    }
    resultarr3.push(tempobj)
  }
  const newobj={
      name: "Total",
      status1:getSumByKey(resultarr3,"status1"),
      status2:getSumByKey(resultarr3,"status2"),
      status3:getSumByKey(resultarr3,"status3"),
      status4:getSumByKey(resultarr3,"status4"),
      status1p:Math.round(getSumByKey(resultarr3,"status1")/getSumByKey(resultarr3,"total")*100),
      status2p:Math.round(getSumByKey(resultarr3,"status2")/getSumByKey(resultarr3,"total")*100),
      status3p:Math.round(getSumByKey(resultarr3,"status3")/getSumByKey(resultarr3,"total")*100),
      status4p:Math.round(getSumByKey(resultarr3,"status4")/getSumByKey(resultarr3,"total")*100),
      total:getSumByKey(resultarr3,"total"),
  }
  resultarr3.push(newobj)
 }
  //console.log(resultarr3)
//-------------------------------------------------------------------------------
  //status wise lead quality
  var campaigninfo=[]
  var metacampaigninfo=[], metasubplatform=[], metaadinfo=[]
  var finalresult=[]
  if(listleadData2.length > 0){
     const metaresult=groupBy(listleadData2, v=>v.lead_meta_campaign)
    for (let [key, value] of metaresult) {
      metacampaigninfo.push(key)
      }
    const metaadresult=groupBy(listleadData2, v=>v.lead_ad)
    for (let [key, value] of metaadresult) {
      metaadinfo.push(key)
      }
    
    const result=groupBy(listleadData2, v=>v.lead_campaign)
    for (let [key, value] of result) {
      campaigninfo.push(key)
    }

    const spresult=groupBy(listleadData2, v=>v.lead_sub_platform)
    for (let [key, value] of spresult) {
      metasubplatform.push(key)
      }
      //setcampaigndata(resultobject4)
    if(searchData6.destination_type){
      if(searchData6.destination_type=="Domestic"){
        listleadData2=listleadData2.filter(lead => lead.lead_destination=="Kashmir" || lead.lead_destination=="Kerala" || lead.lead_destination=="Goa" || lead.lead_destination=="Andaman" || lead.lead_destination=="Himachal" || lead.lead_destination=="Meghalaya" || lead.lead_destination=="Rajasthan" || lead.lead_destination=="Sikkim-Darjeeling" || lead.lead_destination=="Uttarakhand" || lead.lead_destination=="North-East" || lead.lead_destination=="Ladakh" || lead.lead_destination=="Tamil Nadu" || lead.lead_destination=="Gujarat" || lead.lead_destination=="Golden Triangle")
      }else if(searchData6.destination_type=="International"){
        listleadData2=listleadData2.filter(lead => lead.lead_destination=="Bali" || lead.lead_destination=="Thailand" || lead.lead_destination=="Dubai" || lead.lead_destination=="Singapore" || lead.lead_destination=="Malaysia" || lead.lead_destination=="Maldives" || lead.lead_destination=="Vietnam" || lead.lead_destination=="Mauritius" || lead.lead_destination=="Sri Lanka" || lead.lead_destination=="Turkey" || lead.lead_destination=="Azerbaijan" || lead.lead_destination=="Europe" || lead.lead_destination=="Georgia" || lead.lead_destination=="Nepal" || lead.lead_destination=="Uzbekistan" || lead.lead_destination=="Cambodia" || lead.lead_destination=="Kazakhstan" || lead.lead_destination=="Philippines")
      }else if(searchData6.destination_type=="Others"){
        listleadData2=listleadData2.filter(lead => lead.lead_destination!=="Bali" && lead.lead_destination!=="Thailand"  && lead.lead_destination!=="Philippines" && lead.lead_destination!=="Dubai" && lead.lead_destination!=="Turkey"&& lead.lead_destination!=="Singapore" && lead.lead_destination!=="Malaysia" && lead.lead_destination!=="Maldives" && lead.lead_destination!=="Vietnam" && lead.lead_destination!=="Mauritius" && lead.lead_destination!=="Sri Lanka" && lead.lead_destination!=="Kashmir" && lead.lead_destination!=="Kerala" && lead.lead_destination!=="Goa" && lead.lead_destination!=="Andaman" && lead.lead_destination!=="Himachal" && lead.lead_destination!=="Meghalaya" && lead.lead_destination!=="Rajasthan" && lead.lead_destination!=="Sikkim-Darjeeling" && lead.lead_destination!=="Uttarakhand" && lead.lead_destination!=="North-East" && lead.lead_destination!=="Ladakh" && lead.lead_destination!=="Tamil Nadu" && lead.lead_destination!=="Gujarat" && lead.lead_destination!=="Golden Triangle" && lead.lead_destination!=="Azerbaijan" && lead.lead_destination!=="Europe" && lead.lead_destination!=="Georgia" && lead.lead_destination!=="Cambodia" && lead.lead_destination!=="Kazakhstan" && lead.lead_destination!=="Nepal"  && lead.lead_destination!=="Uzbekistan")
      }
      
    }
    if(searchData6.destination){
      if(searchData6.destination.includes("Clear")){

      }else{
      listleadData2=listleadData2.filter(lead =>searchData6.destination.includes(lead.lead_destination))
      }
    }
    if(searchData6.campaign){
      if(searchData6.campaign=="Pure Organic"){
        listleadData2=listleadData2.filter(lead => lead.lead_campaign=="Website" || lead.lead_campaign=="Destination Pages" || lead.lead_campaign=="WA-linkshare" || lead.lead_campaign=="Destination Selector" || lead.lead_campaign=="Call" || (lead.lead_campaign=="Meta Chat" && lead.lead_platform=="Organic") || lead.lead_campaign=="WA-Campaign")
      }else{
        listleadData2=listleadData2.filter(lead => lead.lead_campaign==searchData6.campaign)
      }
     
    }
    if(searchData6.owner){
      if(searchData6.owner.includes("Clear")){

      }else{
      listleadData2=listleadData2.filter(lead => "lead_owner" in lead && searchData6.owner.includes(lead.lead_owner))
      }
    }
    if(searchData6.status_present=="OS"){
      listleadData2=listleadData2.filter(lead => lead.lead_status)
    }
    if(searchData6.lead_platform){
      listleadData2=listleadData2.filter(lead => lead.lead_platform==searchData6.lead_platform)
    }

    if(searchData6.decision_stage){
      listleadData2=listleadData2.filter(lead => lead.lead_status==searchData6.decision_stage)
    }
    if(searchData6.ttb){
      listleadData2=listleadData2.filter(lead => lead.time_to_book==searchData6.ttb)
    }
    if(searchData6.tl){
      listleadData2=listleadData2.filter(lead => gettl(lead.lead_owner)==searchData6.tl)
    }

    if(searchData6.quality){
      if(searchData6.quality=="High Quality"){
        listleadData2=listleadData2.filter(lead => newgetqualitylead(lead)!=="Iron" && newgetqualitylead(lead)!=="Copper" && newgetqualitylead(lead)!=="Silver")
      }else if(searchData6.quality=="Low Quality"){
       listleadData2=listleadData2.filter(lead => newgetqualitylead(lead)=="Iron" || newgetqualitylead(lead)=="Copper" || newgetqualitylead(lead)=="Silver"|| getquality(lead)=="Titanium")
      }else if(searchData6.quality=="Old Low Quality"){
       listleadData2=listleadData2.filter(lead => newgetqualitylead(lead)=="Iron" || newgetqualitylead(lead)=="Copper" || newgetqualitylead(lead)=="Titanium")
      }else if(searchData6.quality=="Old High Quality"){
       listleadData2=listleadData2.filter(lead => newgetqualitylead(lead)!=="Iron" && newgetqualitylead(lead)!=="Copper")
      }else{
        listleadData2=listleadData2.filter(lead => newgetqualitylead(lead)==searchData6.quality)
      }
    
    }
    if(searchData6.passport){
      listleadData2=listleadData2.filter(lead => lead.lead_passport==searchData6.passport)
    }
    if(searchData6.quote){
      listleadData2=listleadData2.filter(lead => lead.lead_other_quotes==searchData6.quote)
    }
    if(searchData6.lead_canc_reason){
      listleadData2=listleadData2.filter(lead => lead.canc_reason==searchData6.lead_canc_reason)
    }
     if(searchData6.flightreq==1){
      listleadData2=listleadData2.filter(lead => lead.flight_required==searchData6.flightreq)
    }
     if(searchData6.flightreq=="Null"){
      listleadData2=listleadData2.filter(lead =>!("flight_required" in lead))
    }
    if(searchData6.fast_reach!==""){
    if(searchData6.fast_reach){
      listleadData2=listleadData2.filter(lead => lead.fast_reach==searchData6.fast_reach)
    }
    if(searchData6.fast_reach==false){
      listleadData2=listleadData2.filter(lead => !("fast_reach" in lead && lead.fast_reach))
    }
  }
  if(searchData6.cust_type){
   
      listleadData2=listleadData2.filter(lead => lead.customer_type==searchData6.cust_type)
    
  }
  if(searchData6.fast_reach_attempted!==""){
    if(searchData6.fast_reach_attempted){
      listleadData2=listleadData2.filter(lead => lead.fast_reach_attempted==searchData6.fast_reach_attempted)
    }
    if(searchData6.fast_reach_attempted==false){
      listleadData2=listleadData2.filter(lead => !("fast_reach_attempted" in lead && lead.fast_reach_attempted))
    }
  }
  if(searchData6.manual_fr!==""){
    if(searchData6.manual_fr){
      listleadData2=listleadData2.filter(lead => lead.manual_fast_reach==searchData6.manual_fr)
    }
    if(searchData6.manual_fr==false){
      listleadData2=listleadData2.filter(lead => !("manual_fast_reach" in lead && lead.manual_fast_reach))
    }
  }
  if(searchData6.manual_fr_attempted!==""){
    if(searchData6.manual_fr_attempted){
      listleadData2=listleadData2.filter(lead => lead.manual_fast_reach_attempted==searchData6.manual_fr_attempted)
    }
    if(searchData6.manual_fr_attempted==false){
      listleadData2=listleadData2.filter(lead => !("manual_fast_reach_attempted" in lead && lead.manual_fast_reach_attempted))
    }
  }
  if(searchData6.manual_fr_failed!==""){
    if(searchData6.manual_fr_failed){
      listleadData2=listleadData2.filter(lead => lead.manual_fast_reach_failed==searchData6.manual_fr_failed)
    }
    if(searchData6.manual_fr_failed==false){
      listleadData2=listleadData2.filter(lead => !("manual_fast_reach_failed" in lead && lead.manual_fast_reach_failed))
    }
  }
  if(!(searchData6.meta_sub_platform=="" || searchData6.meta_sub_platform==undefined)){
    
      listleadData2=listleadData2.filter(lead => lead.lead_sub_platform==searchData6.meta_sub_platform)
    
    
  }
  //console.log(searchData6.meta_sub_platform)
  if(searchData6.mode=="Support Owner"){
    listleadData2=listleadData2.filter(l=>"lead_owner_support" in l)
  }
  if(searchData6.lead_meta_campaign){
    listleadData2=listleadData2.filter(l=>l.lead_meta_campaign==searchData6.lead_meta_campaign)
  }
  if(searchData6.lead_meta_ad){
    listleadData2=listleadData2.filter(l=>l.lead_ad==searchData6.lead_meta_ad)
  }
  if(searchData6.support_owner){
    listleadData2=listleadData2.filter(l=>l.lead_owner_support==searchData6.support_owner)
  }
  if(searchData6.model){
    if(searchData6.model=="Beta"){
    listleadData2=listleadData2.filter(l=>"model_beta" in l && l.model_beta=="Beta")
  }else if(searchData6.model=="Alpha"){
    listleadData2=listleadData2.filter(l=>!("model_beta" in l && l.model_beta=="Beta"))
  }
}
    //console.log(listleadData2)
    const lc=listleadData2.filter(lead=>lead.lead_platform!=="Meta")
    // const result3=groupBy(lc, v=>v.current_url)
    //   console.log(result3)
    let resultobject=[]
    let resultobject3=[]
    let resultobject4=[]
    let resultobject5=[]
    let resultobject6=[]
    let resultobject7=[]
    let resultobject8=[]
    let resultobject9=[]
    let resultobject1=[]
    let resultobject2=[]
    var result2={}
    //console.log(searchData6.mode)
    if(searchData6.mode=="Time to book"){
      result2=groupBy(listleadData2, v=>v.time_to_book)
    }else if(searchData6.mode=="Decision Stage"){
      result2=groupBy(listleadData2, v=>v.lead_status)
    }else if(searchData6.mode=="Destination"){
      result2=groupBy(listleadData2, v=>v.lead_destination)
    }else if(searchData6.mode=="Salesperson"){
      result2=groupBy(listleadData2, v=>v.lead_owner)
    }else if(searchData6.mode=="Channel"){
      result2=groupBy(listleadData2, v=>v.lead_platform)
    }else if(searchData6.mode=="Campaign"){
      result2=groupBy(listleadData2, v=>v.lead_campaign)
    }else if(searchData6.mode=="Date"){
      result2=groupBy(listleadData2, v=>DateCalc2(v.createdAt,0))
    }else if(searchData6.mode=="Potential"){
      result2=groupBy(listleadData2, v=>v.potential)
    }else if(searchData6.mode=="Reach"){
      for(let i=0; i<listleadData2.length; i++){
        if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<1){
          listleadData2[i].reach_category="1-Less than 1"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=1 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<4){
          listleadData2[i].reach_category="2-Between 1 and 4"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=4 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<8){
          listleadData2[i].reach_category="3-Between 4 and 8"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=8 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<12){
          listleadData2[i].reach_category="4-Between 8 and 12"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=12 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<24){
          listleadData2[i].reach_category="5-Between 12 and 24"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=24 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<48){
          listleadData2[i].reach_category="6-Between 24 and 48"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=48 && ((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<72){
          listleadData2[i].reach_category="7-Between 48 and 72"
        }else if(((new Date(listleadData2[i].work_complete_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=72){
          listleadData2[i].reach_category="8-More than 72"
        }
      }
      result2=groupBy(listleadData2, v=>v.reach_category)
    }else if(searchData6.mode=="First Reach Attempt"){
      //console.log(listleadData2)
      for(let i=0; i<listleadData2.length; i++){
        if("callrecord" in listleadData2[i] && listleadData2[i].callrecord.length>0){
        if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<1){
          listleadData2[i].time_gap="1-Less than 1"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=1 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<4){
          listleadData2[i].time_gap="2-Between 1 and 4"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=4 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<8){
          listleadData2[i].time_gap="3-Between 4 and 8"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=8 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<12){
          listleadData2[i].time_gap="4-Between 8 and 12"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=12 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<24){
          listleadData2[i].time_gap="5-Between 12 and 24"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=24 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<48){
          listleadData2[i].time_gap="6-Between 24 and 48"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=48 && ((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))<72){
          listleadData2[i].time_gap="7-Between 48 and 72"
        }else if(((new Date(listleadData2[i].callrecord[0].start_stamp).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60))>=72){
          console.log(listleadData2[i])
          listleadData2[i].time_gap="8-More than 72"
        }
      }
      }
      result2=groupBy(listleadData2, v=>v.time_gap)
    }else if(searchData6.mode=="FC Time"){
      for(let i=0; i<listleadData2.length; i++){
        if("callrecord" in listleadData2[i] && listleadData2[i].callrecord.length>0){
          var sum=0
          for(let j=0; j<listleadData2[i].callrecord.length; j++){
            sum=listleadData2[i].callrecord[j].outbound_sec=""?sum:sum+Number(listleadData2[i].callrecord[j].outbound_sec)
          }
          if(sum==0){
            listleadData2[i].fc_time_category="1-Zero"
          }else if(sum>0 && sum<60){
            listleadData2[i].fc_time_category="2-0 to 1 min"
          }else if(sum>=60 && sum<120){
            listleadData2[i].fc_time_category="3-1 to 2 min"
          }else if(sum>=120 && sum<180){
            listleadData2[i].fc_time_category="4-2 to 3 min"
          }else if(sum>=180 && sum<240){
             listleadData2[i].fc_time_category="5-3 to 4 min"
          }else if(sum>=240 && sum<300){
            listleadData2[i].fc_time_category="6-4 to 5 min"
          }else if(sum>=300){
            listleadData2[i].fc_time_category="7-More than 5"
          }
        }else{
          listleadData2[i].fc_time_category="No Record"
        }
        
      }
      console.log(listleadData2)
      result2=groupBy(listleadData2, v=>v.fc_time_category)
    }else if(searchData6.mode=="Pax"){
      result2=groupBy(listleadData2, v=>v.lead_child?Number(v.lead_pax)+Number(v.lead_child):Number(v.lead_pax))
    }else if(searchData6.mode=="Budget"){
      result2=groupBy(listleadData2, v=>v.lead_budget)
    }else if(searchData6.mode=="Flight Req"){
      result2=groupBy(listleadData2, v=>v.flight_required)
    }else if(searchData6.mode=="Airport"){
      result2=groupBy(listleadData2, v=>v.lead_source_airport)
    }else if(searchData6.mode=="Support Owner"){
      result2=groupBy(listleadData2, v=>v.lead_owner_support)
    }else if(searchData6.mode=="WA Only"){
      result2=groupBy(listleadData2, v=>v.only_whatsapp)
    }else if(searchData6.mode=="Canc Reason"){
      result2=groupBy(listleadData2, v=>v.canc_reason)
    }else if(searchData6.mode=="Canc Reason Notes"){
      result2=groupBy(listleadData2, v=>v.canc_reason_notes)
    }else if(searchData6.mode=="Created At"){
      for(let i=0; i<listleadData2.length; i++){
        // console.log(i)
        const istDate=new Date(listleadData2[i].createdAt).getTime()+ 5.5 * 60 * 60 * 1000
        // console.log(istDate)
        const hour = new Date(istDate).getHours();
        // console.log(hour)
        if(hour<8){
          listleadData2[i].created_category="1-Less than 8"
        }else  if(hour<11 && hour>=8){
          listleadData2[i].created_category="2-Between 8 and 11"
        }else  if(hour<19 && hour>=11){
          listleadData2[i].created_category="3-Between 11 and 19"
        }else  if(hour<22 && hour>=19){
          listleadData2[i].created_category="4-Between 19 and 22"
        }else  if(hour>22){
          listleadData2[i].created_category="5-More than 22"
        }
      }
      result2=groupBy(listleadData2, v=>v.created_category)
    }else if(searchData6.mode=="Time To Travel"){
      for(let i=0; i<listleadData2.length; i++){
        const gap=Math.round((new Date(listleadData2[i].lead_travel_date).getTime()-new Date(listleadData2[i].createdAt).getTime())/(1000*60*60*24))
        if(gap<15){
          listleadData2[i].gap_category="1-Less than 15"
        }else  if(gap<31 && gap>=16){
          listleadData2[i].gap_category="2-Between 16 and 30"
        }else  if(gap<61 && gap>=30){
          listleadData2[i].gap_category="3-Between 31 and 60"
        }else  if(gap<91 && gap>=60){
          listleadData2[i].gap_category="4-Between 61 and 90"
        }else  if(gap<121 && gap>=90){
          listleadData2[i].gap_category="5-Between 91 and 120"
        }else  if(gap<181 && gap>=120){
          listleadData2[i].gap_category="6-Between 121 and 180"
        }else  if(gap>180){
          listleadData2[i].gap_category="7-More than 180"
        }
      }
      result2=groupBy(listleadData2, v=>v.gap_category)
    }
    else if(searchData6.mode=="Ad"){
      result2=groupBy(listleadData2, v=>v.lead_ad)
    }
     else if(searchData6.mode=="Sub-platform"){
      result2=groupBy(listleadData2, v=>v.lead_sub_platform)
    }
    else if(searchData6.mode=="Initial Quality"){
      result2=groupBy(listleadData2, v=>newgetqualitylead(v, true))
      //result2=groupBy(listleadData2, v=>newgetqualitylead(v))
    } else if(searchData6.mode=="Interest Urgent"){
      result2=groupBy(listleadData2, v=>v.lead_interest_wa)
    } else if(searchData6.mode=="Interest WA"){
      result2=groupBy(listleadData2, v=>v.lead_interest_urgent)
    }
    else if(searchData6.mode=="Customer Type"){
      result2=groupBy(listleadData2, v=>v.customer_type)
    }
    else if(searchData6.mode=="Meta Campaign"){
      result2=groupBy(listleadData2, v=>v.lead_meta_campaign)
    }
    else if(searchData6.mode=="Landing Page"){
      result2=groupBy(listleadData2, v=>v.landing_page)
    }
    else if(searchData6.mode=="Lead Place Count"){
      result2=groupBy(listleadData2, v=>v.lead_place_count)
    }
    else if(searchData6.mode=="Lead Assigned By"){
      result2=groupBy(listleadData2, v=>v.lead_assigned_by)
    }
    else if(searchData6.mode=="Fast Reach"){
      result2=groupBy(listleadData2, v=>v.fast_reach)
    }
     else if(searchData6.mode=="Fast Reach Attempted"){
      result2=groupBy(listleadData2, v=>v.fast_reach_attempted)
    }
     else if(searchData6.mode=="Manual Fast Reach"){
      result2=groupBy(listleadData2, v=>v.manual_fast_reach)
    }
     else if(searchData6.mode=="Manual Fast Reach Attempted"){
      result2=groupBy(listleadData2, v=>v.manual_fast_reach_attempted)
    }
    else if(searchData6.mode=="Travel Date"){
      result2=groupBy(listleadData2, v=>v.lead_travel_date)
    }
    else if(searchData6.mode=="TL"){
      result2=groupBy(listleadData2, v=>gettl(v.lead_owner))
    }
    else if(searchData6.mode=="Ref Code"){
      result2=groupBy(listleadData2, v=>v.ref_code)
    }
    else if(searchData6.mode=="Model"){
      result2=groupBy(listleadData2, v=>v.model_beta)
    }
    else{
      result2=groupBy(listleadData2, v=>newgetqualitylead(v))
    }
    
    for (let [key, value] of result2) {
      let sum=0, sumhot=0, sumconv=0, sumbo=0, sumpot=0, sumwd=0, sumactive=0, sumtrip=0
      for(let j=0;j<value.length;j++){
        // for(let p=0;p<listleadData2.length;p++){
          if("potential" in value[j] && value[j].potential){
            sumpot++
          }
          if("work_complete" in value[j] && value[j].work_complete){
            sumwd++
          }
        // }
        //const checkHot = listhottripData2 => listhottripData2.lead.lead_id === value[j].lead_id
        for(let k=0; k<listhottripData2.length;k++){
        if(value[j].lead_id==listhottripData2[k].lead.lead_id){
          sumhot++
        }
      }
      for(let m=0; m<listconvtripData2.length;m++){
        if(value[j].lead_id==listconvtripData2[m].lead.lead_id){
          ////console.log converted trip ids here
          //console.log("Trip Id:"+listconvtripData2[m].trip_id+" || Lead Id:"+listconvtripData2[m].lead.lead_id)
          sumconv++
        }
      }
      for(let n=0; n<listbotripData.length;n++){
        if(value[j].lead_id==listbotripData[n].lead.lead_id){
          sumbo++
        }
      }
      for(let o=0; o<listactivetripData.length;o++){
        if(value[j].lead_id==listactivetripData[o].lead.lead_id){
          sumactive++
        }
      }
       for(let o=0; o<triplistfromleadlist.length;o++){
        if(value[j].lead_id==triplistfromleadlist[o].lead.lead_id){
          sumtrip++
        }
      }
        if(value[j].canc_reason && value[j].cust_create!==true){
          sum++
        }
      }
      resultobject1.push(sumactive)
      resultobject2.push(sumtrip)
      resultobject4.push(sum)
      resultobject5.push(sumhot)
      resultobject6.push(sumconv)
      resultobject7.push(sumbo)
      resultobject8.push(sumpot)
      resultobject9.push(sumwd)
      resultobject.push(value.length)
      resultobject3.push(key)
      }
      //console.log(resultobject1)
      for(let i=0; i<resultobject3.length; i++) {
       const tempobj={
        status:resultobject3[i],
        count:resultobject[i],
        percentage:(resultobject[i]/listleadData2.length*100).toFixed(1),
        canc_lead:resultobject4[i]+" ("+Math.round(resultobject4[i]/resultobject[i]*100)+"%)",
        pot:resultobject8[i]+" ("+Math.round(resultobject8[i]/resultobject[i]*100)+"%)",
        work_done:resultobject9[i]+" ("+Math.round(resultobject9[i]/resultobject[i]*100)+"%)",
        hot_lead:resultobject5[i],
        hot_lead_per:(resultobject5[i]/resultobject[i]*100).toFixed(2),
        conv_lead:resultobject6[i],
        conv_lead_per:(resultobject6[i]/resultobject[i]*100).toFixed(2),
        bo_lead:resultobject7[i],
        bo_lead_per:(resultobject7[i]/resultobject[i]*100).toFixed(2),
        active_lead:resultobject1[i],
        active_lead_per:(resultobject1[i]/resultobject[i]*100).toFixed(2),
        trip_created:resultobject2[i],
        trip_created_per:(resultobject2[i]/resultobject[i]*100).toFixed(2),
       }
       finalresult.push(tempobj)
      }
      const arrsum=resultobject4.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum7=resultobject2.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum1=resultobject1.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum2=resultobject5.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum3=resultobject6.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum4=resultobject7.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum5=resultobject8.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum6=resultobject9.reduce((partialSum, a) => partialSum + a, 0)
      
      //const arrsum5=listleadData2.filter(l=>"potential" in l && l.potential)
      const totalobj={
        status:"Total",
        count:listleadData2.length,
        canc_lead:arrsum +" ("+Math.round(arrsum/listleadData2.length*100)+"%)",
        //canc_lead_per:Math.round(arrsum/listleadData2.length*100),
        pot:arrsum5 +" ("+Math.round(arrsum5/listleadData2.length*100)+"%)",
        //pot_percentage:Math.round(arrsum5/listleadData2.length*100),
        work_done:arrsum6 +" ("+Math.round(arrsum6/listleadData2.length*100)+"%)",
        trip_created:arrsum7,
        trip_created_per:(arrsum7/listleadData2.length*100).toFixed(2),
        hot_lead:arrsum2,
        hot_lead_per:(arrsum2/listleadData2.length*100).toFixed(2),
        conv_lead:arrsum3,
        conv_lead_per:(arrsum3/listleadData2.length*100).toFixed(2),
        bo_lead:arrsum4,
        bo_lead_per:(arrsum4/listleadData2.length*100).toFixed(2),
        active_lead:arrsum1,
        active_lead_per:(arrsum1/listleadData2.length*100).toFixed(2),
      }
      finalresult.push(totalobj)

      //lead quality metrics
      var frfailed=listleadData2.filter(lead => lead.manual_fast_reach_failed)
      var frpassed=listleadData2.filter(lead => lead.manual_fast_reach)
      var frattempted=listleadData2.filter(lead => lead.manual_fast_reach_attempted)
      var frfailedbutna=listleadData2.filter(lead => lead.manual_fast_reach_failed && !("manual_fast_reach_attempted" in lead && lead.manual_fast_reach_attempted))
      var frpassedbutna=listleadData2.filter(lead => lead.manual_fast_reach && !("manual_fast_reach_attempted" in lead && lead.manual_fast_reach_attempted))
      frperc=(frpassed.length/(frfailed.length+frpassed.length)*100).toFixed(1)
      frq=((frfailed.length+frpassed.length)/(frattempted.length+frfailedbutna.length+frpassedbutna.length)*100).toFixed(1)

      var iron=listleadData2.filter(lead => newgetqualitylead(lead)=="Iron")
      var copper=listleadData2.filter(lead => newgetqualitylead(lead)=="Copper")
      var silver=listleadData2.filter(lead => newgetqualitylead(lead)=="Silver")
      var titanium=listleadData2.filter(lead => newgetqualitylead(lead)=="Titanium")
      titaniumcount=(titanium.length/(silver.length+copper.length+iron.length+titanium.length)*100).toFixed(1)

      var allleadid=listleadData2.map(l=>l.lead_id)
      var reltrips=triplistfromleadlist.filter(t=>allleadid.includes(t.lead.lead_id))
      totalcanc=reltrips.filter(t=>t.trip_status=="Cancelled")
      var canc=reltrips.filter(t=>t.trip_status=="Cancelled")
      nrcanc=canc.filter(c=>c.canc_reason=="System-no response category 5" || c.canc_reason=="System-no response category 4" || c.canc_reason=="System-no response category 3" || c.canc_reason=="System-no response category 2" || c.canc_reason=="System-no response category 1")
      // console.log(reltrips)
      // console.log(totalcanc)
      // console.log(nrcanc)

      hqleads=listleadData2.filter(lead => newgetqualitylead(lead)=="Rhodium" || newgetqualitylead(lead)=="Platinum" || newgetqualitylead(lead)=="Diamond" || newgetqualitylead(lead)=="Gold" )
      var hqleadlist=hqleads.map(l=>l.lead_id)
      hqtrips=triplistfromleadlist.filter(t=>hqleadlist.includes(t.lead.lead_id))
  }
  
  //console.log(finalresult)
  //trip status wise trip quality
  
  var triparr2=[...listtripData2]
  var triparr=triparr2.filter(trip=>"lead_details" in trip && trip.lead_details.length>0)
  if(listtripData2.length > 0){
    //var listleadData3=listleadData2.filter(lead => lead.canc_reason)
    
    // const result=groupBy(listtripData2, v=>v.lead_campaign)
    // for (let [key, value] of result) {
    //   campaigninfo.push(key)
    //   }
      //setcampaigndata(resultobject4)
    if(searchData6.destination_type){
      if(searchData6.destination_type=="Domestic"){
        triparr=triparr.filter(trip => trip.primary_destination=="Kashmir" || trip.primary_destination=="Kerala" || trip.primary_destination=="Goa" || trip.primary_destination=="Andaman" || trip.primary_destination=="Himachal" || trip.primary_destination=="Meghalaya" || trip.primary_destination=="Rajasthan" || trip.primary_destination=="Sikkim-Darjeeling" || trip.primary_destination=="Uttarakhand" || trip.primary_destination=="North-East" || trip.primary_destination=="Ladakh" || trip.primary_destination=="Tamil Nadu" || trip.primary_destination=="Gujarat" || trip.primary_destination=="Golden Triangle")
      }else if(searchData6.destination_type=="International"){
        triparr=triparr.filter(trip => trip.primary_destination=="Bali" || trip.primary_destination=="Thailand" || trip.primary_destination=="Philippines" || trip.primary_destination=="Dubai" || trip.primary_destination=="Singapore" || trip.primary_destination=="Malaysia" || trip.primary_destination=="Maldives" || trip.primary_destination=="Vietnam" || trip.primary_destination=="Mauritius" || trip.primary_destination=="Sri Lanka" || trip.primary_destination=="Turkey")
      }else if(searchData6.destination_type=="Others"){
        triparr=triparr.filter(trip => trip.primary_destination!=="Bali" && trip.primary_destination!=="Thailand" && trip.primary_destination!=="Philippines" && trip.primary_destination!=="Dubai" && trip.primary_destination!=="Turkey"&& trip.primary_destination!=="Singapore" && trip.primary_destination!=="Malaysia" && trip.primary_destination!=="Maldives" && trip.primary_destination!=="Vietnam" && trip.primary_destination!=="Mauritius" && trip.primary_destination!=="Sri Lanka" && trip.primary_destination!=="Kashmir" && trip.primary_destination!=="Kerala" && trip.primary_destination!=="Goa" && trip.primary_destination!=="Andaman" && trip.primary_destination!=="Himachal" && trip.primary_destination!=="Meghalaya" && trip.primary_destination!=="Rajasthan" && trip.primary_destination!=="Sikkim-Darjeeling" && trip.primary_destination!=="Uttarakhand" && trip.primary_destination!=="North-East" && trip.primary_destination!=="Ladakh" && trip.primary_destination!=="Tamil Nadu" && trip.primary_destination!=="Gujarat" && trip.primary_destination!=="Golden Triangle")
      }
      
    }
    if(searchData6.campaign){
      if(searchData6.campaign=="Pure Organic"){
        triparr=triparr.filter(trip => (trip.lead_details[0].lead_campaign=="Website" || trip.lead_details[0].lead_campaign=="Destination Pages" || trip.lead_details[0].lead_campaign=="WA-linkshare" || trip.lead_details[0].lead_campaign=="Destination Selector"))
      }else{
        triparr=triparr.filter(trip => trip.lead_details[0].lead_campaign==searchData6.campaign)
      }
     
    }
    if(searchData6.owner){
      if(searchData6.owner.includes("Clear")){

      }else{
      triparr=triparr.filter(trip => "trip_owner" in trip && searchData6.owner.includes(trip.trip_owner))
      }
    }
    if(searchData6.destination){
      if(searchData6.destination.includes("Clear")){

      }else{
      triparr=triparr.filter(trip => searchData6.destination.includes(trip.primary_destination))
      }
    }
    if(searchData6.status_present=="OS"){
      triparr=triparr.filter(trip => trip.lead_details[0].lead_status)
    }
    if(searchData6.lead_platform){
      triparr=triparr.filter(trip => trip.lead_details[0].lead_platform==searchData6.lead_platform)
    }

    if(searchData6.decision_stage){
      triparr=triparr.filter(trip => trip.lead_details[0].lead_status==searchData6.decision_stage)
    }
    if(searchData6.ttb){
      triparr=triparr.filter(trip => trip.lead_details[0].time_to_book==searchData6.ttb)
    }

    if(searchData6.quality){
      if(searchData6.quality=="High Quality"){
        triparr=triparr.filter(trip => getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)!=="Iron" && getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)!=="Copper")
      }else if(searchData6.quality=="Old High Quality"){
    triparr=triparr.filter(trip => getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)!=="Iron" && getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)!=="Copper" && getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)!=="Silver")
      }else if(searchData6.quality=="Low Quality"){
        triparr=triparr.filter(trip => getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Iron" || getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Copper" || getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Titanium")
      }else if(searchData6.quality=="Old Low Quality"){
        triparr=triparr.filter(trip => getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Iron" || getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Copper" || getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Silver"|| getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)=="Titanium")
      }else{
        triparr=triparr.filter(trip => getquality(trip.lead_details[0].lead_status,trip.lead_details[0].time_to_book, trip.lead_details[0].lead_platform, trip.lead_details[0].lead_travel_date, trip.lead_details[0].quality_upgrade)==searchData6.quality)
      }
    
    }
    //console.log(triparr.length)
    //const lc=triparr.filter(trip=>trip.lead.lead_platform!=="Meta")
    // const result3=groupBy(lc, v=>v.current_url)
    //   console.log(result3)
    let resultobject=[]
    let resultobject1=[]
    let resultobject3=[]
    let resultobject4=[]
    let resultobject5=[]
    let resultobject6=[]
    let resultobject7=[]
    let resultobject8=[]
    let resultobject9=[]
    let resultobject10=[]
    let resultobject11=[]
    let resultobject12=[]
    var result2={}
    if(searchData6.mode=="Time to book"){
      result2=groupBy(triparr, v=>v.lead_details[0].time_to_book)
    }else if(searchData6.mode=="Decision Stage"){
      result2=groupBy(triparr, v=>v.lead_details[0].lead_status)
    }else if(searchData6.mode=="Destination"){
      result2=groupBy(triparr, v=>v.primary_destination)
    }else if(searchData6.mode=="Salesperson"){
      result2=groupBy(triparr, v=>v.trip_owner)
    }else if(searchData6.mode=="Channel"){
      result2=groupBy(triparr, v=>v.lead_details[0].lead_platform)
    }else if(searchData6.mode=="Campaign"){
      result2=groupBy(triparr, v=>v.lead_details[0].lead_campaign)
    }else if(searchData6.mode=="Date"){
      result2=groupBy(triparr, v=>DateCalc2(v.createdAt,0))
    }else if(searchData6.mode=="Time To Travel"){
      for(let i=0; i<triparr.length; i++){
        var gap=""
        if(getconvdate(triparr[i])){
        gap=Math.round((new Date(triparr[i].trip_start_date).getTime()-new Date(getconvdate(triparr[i])).getTime())/(1000*60*60*24))
        }else{
          gap=Math.round((new Date(triparr[i].trip_start_date).getTime()-new Date(getcancdate(triparr[i])).getTime())/(1000*60*60*24))
        }
        if(gap<15){
          triparr[i].gap_category="1-Less than 15"
        }else  if(gap<31 && gap>=16){
          triparr[i].gap_category="2-Between 16 and 30"
        }else  if(gap<61 && gap>=30){
          triparr[i].gap_category="3-Between 31 and 60"
        }else  if(gap<91 && gap>=60){
          triparr[i].gap_category="4-Between 61 and 90"
        }else  if(gap<121 && gap>=90){
          triparr[i].gap_category="5-Between 91 and 120"
        }else  if(gap<181 && gap>=120){
          triparr[i].gap_category="6-Between 121 and 180"
        }else  if(gap>180){
          triparr[i].gap_category="7-More than 180"
        }
      }
      result2=groupBy(triparr, v=>v.gap_category)
    }
    else{
      result2=groupBy(triparr, v=>"lead_status" in v.lead_details[0]?getquality(v.lead_details[0].lead_status, v.lead_details[0].time_to_book, v.lead_details[0].lead_platform, v.lead_details[0].lead_travel_date, v.lead_details[0].quality_upgrade, v.lead_details[0].lead_passport,  v.lead_details[0].lead_campaign, v.lead_details[0].flight_required, v.lead_details[0].customer_type):getquality(null, v.lead_details[0].time_to_book, v.lead_details[0].lead_platform, v.lead_details[0].lead_travel_date, v.lead_details[0].quality_upgrade,  v.lead_details[0].lead_passport,  v.lead_details[0].lead_campaign, v.lead_details[0].flight_required, v.lead_details[0].customer_type))
    }
    console.log(triparr)
    for (let [key, value] of result2) {
      let sum=0, sumhot=0, sumconv=0, sumbo=0, sumpot=0, sumdays2cancel=0, sumdays2convert=0, sumprofit=0, sumhot2convert=0, sumactive=0
      for(let j=0;j<value.length;j++){
        // for(let p=0;p<listleadData2.length;p++){
          if("potential" in value[j].lead_details[0] && value[j].lead_details[0].potential){
            sumpot++
          
          }

          if(value[j].trip_status=="Cancelled"){
            sumdays2cancel=sumdays2cancel+(new Date(value[j].canc_flag_time).getTime()-new Date(value[j].createdAt).getTime())/(1000*60*60*24)
          }

          if(value[j].trip_status=="Converted" || value[j].trip_status=="Closed"){
            sumdays2convert=sumdays2convert+(new Date(getconvdatearray(value[j].status_history)).getTime()-new Date(value[j].createdAt).getTime())/(1000*60*60*24)
            sumprofit=sumprofit+getprofit(value[j])
            sumhot2convert=sumhot2convert+(new Date(getconvdatearray(value[j].status_history)).getTime()-new Date(gethotdatearray(value[j].status_history)).getTime())/(1000*60*60*24)
          }
          //console.log(sumdays2convert)
        // }
        //const checkHot = listhottripData2 => listhottripData2.lead.lead_id === value[j].lead_id
        for(let k=0; k<listhottripData2.length;k++){
        if(value[j].trip_id==listhottripData2[k].trip_id){
          sumhot++
        }
      }
      for(let m=0; m<listconvtripData2.length;m++){
        if(value[j].trip_id==listconvtripData2[m].trip_id){
          sumconv++
        }
      }
      for(let n=0; n<listbotripData.length;n++){
        if(value[j].trip_id==listbotripData[n].trip_id){
          sumbo++
        }
      }
      for(let n=0; n<listactivetripData.length;n++){
        if(value[j].trip_id==listactivetripData[n].trip_id){
          sumactive++
        }
      }
        if(value[j].trip_status=="Cancelled"){
          sum++
        }
      }
      resultobject1.push(sumactive)
      resultobject4.push(sum)
      resultobject5.push(sumhot)
      resultobject6.push(sumconv)
      resultobject7.push(sumbo)
      resultobject8.push(sumpot)
      resultobject.push(value.length)
      resultobject3.push(key)
      resultobject9.push(sumdays2cancel)
      resultobject10.push(sumdays2convert)
      resultobject11.push(sumprofit)
      resultobject12.push(sumhot2convert)
      }
      //console.log(resultobject9)
      //console.log(resultobject10)
      for(let i=0; i<resultobject3.length; i++) {
       const tempobj={
        status:resultobject3[i],
        count:resultobject[i],
        days_to_convert: (resultobject10[i]/resultobject6[i]).toFixed(2),
        hot_to_convert: (resultobject12[i]/resultobject6[i]).toFixed(2),
        canc_lead:resultobject4[i]+" ("+Math.round(resultobject4[i]/resultobject[i]*100)+"%)",
        days_to_cancel:(resultobject9[i]/resultobject4[i]).toFixed(2),
        pot:resultobject8[i]+" ("+Math.round(resultobject8[i]/resultobject[i]*100)+"%)",
        avg_profit:(resultobject11[i]/resultobject6[i]).toFixed(2),
        hot_lead:resultobject5[i],
        hot_lead_per:(resultobject5[i]/resultobject[i]*100).toFixed(2),
        conv_lead:resultobject6[i],
        conv_lead_per:(resultobject6[i]/resultobject[i]*100).toFixed(2),
        bo_lead:resultobject7[i],
        bo_lead_per:(resultobject7[i]/resultobject[i]*100).toFixed(2),
        active_lead:resultobject1[i],
        active_lead_per:(resultobject1[i]/resultobject[i]*100).toFixed(2),
       }
       finalresult.push(tempobj)
      }
      //console.log(finalresult)
      const arrsum=resultobject4.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum1=resultobject1.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum2=resultobject5.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum3=resultobject6.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum4=resultobject7.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum5=resultobject8.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum9=resultobject9.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum10=resultobject10.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum11=resultobject11.reduce((partialSum, a) => partialSum + a, 0)
      const arrsum12=resultobject12.reduce((partialSum, a) => partialSum + a, 0)
      //const arrsum5=listleadData2.filter(l=>"potential" in l && l.potential)
      const totalobj={
        status:"Total",
        count:triparr.length,
        canc_lead:arrsum +" ("+Math.round(arrsum/triparr.length*100)+"%)",
        avg_profit:(arrsum11/arrsum3).toFixed(2),
        pot:arrsum5 +" ("+Math.round(arrsum5/triparr.length*100)+"%)",
        hot_to_convert: (arrsum12/arrsum3).toFixed(2),
        days_to_convert: (arrsum10/arrsum3).toFixed(2),
        days_to_cancel: (arrsum9/arrsum).toFixed(2),
        hot_lead:arrsum2,
        hot_lead_per:(arrsum2/triparr.length*100).toFixed(2),
        conv_lead:arrsum3,
        conv_lead_per:(arrsum3/triparr.length*100).toFixed(2),
        bo_lead:arrsum4,
        bo_lead_per:(arrsum4/triparr.length*100).toFixed(2),
        active_lead:arrsum1,
        active_lead_per:(arrsum1/triparr.length*100).toFixed(2),
      }
      finalresult.push(totalobj)
  }
  //quote Data filter.................................................................................
  var finalquoteData=[...listquoteData2]
  if(filterData.destination){
    finalquoteData=finalquoteData.filter(q=>q.primary_destination==filterData.destination)
  }
  if(filterData.owner){
    finalquoteData=finalquoteData.filter(q=>q.trip_owner==filterData.owner)
  }
  if(filterData.status){
    finalquoteData=finalquoteData.filter(q=>q.trip_status==filterData.status)
  }
  if(filterData.budget){
    finalquoteData=finalquoteData.filter(q=>"base_quote_params" in q && q.base_quote_params.budget==filterData.budget)
  }
  if(filterData.type){
    finalquoteData=finalquoteData.filter(q=>"base_quote_params" in q && q.base_quote_params.cust_type==filterData.type)
  }
  var spwiselist=[]
  var destwiselist=[]
  if(finalquoteData.length>0){
    for(let i=0;i<emp.length;i++){
      var temp=finalquoteData.filter(q=>q.trip_owner==emp[i])
      var t={
        sp:emp[i],
        id:i,
        count:temp.length,
      }
      spwiselist=[...spwiselist, t]
    }
    for(let i=0;i<dest.length;i++){
      var dtemp=finalquoteData.filter(q=>q.primary_destination==dest[i])
      var t={
        dest:dest[i],
        id:i,
        count:dtemp.length,
      //   avg_land_pp:,
      //   avg_flight_pp:,
      //   profit_perc:,
      }
      destwiselist=[...destwiselist, t]
    }
  }
  
  //console.log(finalquoteData)
  //------------------------------------------hot today-------------------------------
  var hot3=[]
  if(searchData9.trip_owner){
    hot3=listhottripData3.filter(t=>t.trip_owner==searchData9.trip_owner)
  }else{
    hot3=listhottripData3
  }
   //------------------------------------------pot today-------------------------------
   var pot3=[...listpottripData]
   if(searchData10.trip_owner){
     pot3=listpottripData.filter(t=>t.trip_owner==searchData10.trip_owner)
   }
   if(searchData10.trip_status){
    pot3=listpottripData.filter(t=>t.trip_status==searchData10.trip_status)
  }

   //------------------------------------competition------------------------------
   var comparr=[...listcomptripData]
   if(searchData11.trip_owner){
    comparr=comparr.filter(trip=>trip.trip_owner==searchData11.trip_owner)
   }
  //final data creation for display
  const analyticsdatalistdisplay6 = finalresult.map((data) => ({
    status:data.status,
    id: finalresult.indexOf(data),
    count:data.count,
    percentage:data.percentage,
    pot:data.pot,
    work_done:data.work_done,
    days_to_cancel:data.days_to_cancel,
    canc_lead:data.canc_lead,
    hot_to_convert:data.hot_to_convert,
    days_to_convert:data.days_to_convert,
    hot_lead:data.hot_lead,
    hot_lead_per:data.hot_lead_per,
    conv_lead:data.conv_lead,
    conv_lead_per:data.conv_lead_per,
    bo_lead:data.bo_lead,
    bo_lead_per:data.bo_lead_per,
    active_lead:data.active_lead,
    active_lead_per:data.active_lead_per,
    avg_profit:data.avg_profit,
    trip_created:data.trip_created,
    trip_created_per:data.trip_created_per,
  }));

  var analyticsdatalistdisplay7 = finalquoteData.map((data) => ({
    quote_id:data.quote_id,
    id: finalquoteData.indexOf(data),
    trip_id:data.trip_id,
    owner:data.trip_owner,
    status:data.trip_status,
    start_date:data.trip_start_date,
    destination:data.primary_destination,
    adult:data.number_adults,
    child:data.number_child,
    duration:data.duration,
    cust_name:data.cust_name,
    flight_sp:"airfare" in data.quote_price?Math.round(data.quote_price.airfare):0,
    flight_pp:"airfare" in data.quote_price?Math.round(data.quote_price.airfare/(data.number_adults+data.number_child)):0,
    land_sp:"landprice" in data.quote_price?data.quote_price.landprice:0,
    land_pp:"landprice" in data.quote_price?Math.round((data.quote_price.landprice/(data.number_adults+data.number_child))/data.duration):0,
    land_per_pax:"landprice" in data.quote_price?Math.round((data.quote_price.landprice/(data.number_adults+data.number_child))):0,
    header:data.sample_package,
    flight_profit:"airfare" in data.quote_price && "airfare" in data.cost_price?Math.round(data.quote_price.airfare-data.cost_price.airfare):0,
    land_profit:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round(data.quote_price.landprice-data.cost_price.landprice):0,
    land_profit_perc:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round((data.quote_price.landprice-data.cost_price.landprice)/data.quote_price.landprice*100):0,
    land_profit_perc_cost:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round((data.quote_price.landprice-data.cost_price.landprice)/data.cost_price.landprice*100):0,
    type:"base_quote_params" in data && "cust_type" in data.base_quote_params?data.base_quote_params.cust_type:"",
    special:"base_quote_params" in data && "special" in data.base_quote_params?data.base_quote_params.special:"",
    budget:"base_quote_params" in data && "budget" in data.base_quote_params?data.base_quote_params.budget:"",
    edit_count:data.edit_count,
    landcpperpp:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round((data.quote_price.landprice/(data.number_adults+data.number_child))/data.duration)*(1-(Math.round((data.quote_price.landprice-data.cost_price.landprice)/data.quote_price.landprice*100))/100):0
  }));

  if(analyticsdatalistdisplay7.length > 0) {
  const temp={
    quote_id:"Total",
    id: analyticsdatalistdisplay7.length,
    trip_id:analyticsdatalistdisplay7.length,
    adult:calculateAverage( analyticsdatalistdisplay7, "adult").toFixed(2),
    child:calculateAverage( analyticsdatalistdisplay7, "child").toFixed(2),
    duration:calculateAverage( analyticsdatalistdisplay7, "duration").toFixed(2),
    cust_name:"",
    flight_sp:calculateAveragewithoutzero( analyticsdatalistdisplay7, "flight_sp").toFixed(2),
    flight_pp:calculateAveragewithoutzero( analyticsdatalistdisplay7, "flight_pp").toFixed(2),
    land_sp:calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_sp").toFixed(2),
    land_pp:calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_pp").toFixed(2),
    land_per_pax: calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_per_pax").toFixed(2),
    flight_profit:calculateAveragewithoutzero( analyticsdatalistdisplay7, "flight_profit").toFixed(2),
    land_profit:calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_profit").toFixed(2),
    land_profit_perc:calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_profit_perc").toFixed(2),
    land_profit_perc_cost:calculateAveragewithoutzero( analyticsdatalistdisplay7, "land_profit_perc_cost").toFixed(2),
    landcpperpp:calculateAveragewithoutzero( analyticsdatalistdisplay7, "landcpperpp").toFixed(2),
  }
  analyticsdatalistdisplay7 = [...analyticsdatalistdisplay7, temp]
}

  const analyticsdatalistdisplay8 = listquoteData3.map((data) => ({
    quote_id:data.quote_id,
    id: listquoteData3.indexOf(data),
    trip_id:data.trip_id,
    owner:data.trip_owner,
    status:data.trip_status,
    destination:data.primary_destination,
    adult:data.number_adults,
    child:data.number_child,
    duration:data.duration,
    cust_name:data.cust_name,
    canc_reason:getcancreason(data.trip_id),
    flight_sp:"quote_price" in data  && "airfare" in data.quote_price?Math.round(data.quote_price.airfare):0,
    flight_pp:"quote_price" in data  && "airfare" in data.quote_price?Math.round(data.quote_price.airfare/(data.number_adults+data.number_child)):0,
    land_sp:"quote_price" in data  && "landprice" in data.quote_price?data.quote_price.landprice:0,
    land_pp:"quote_price" in data  && "landprice" in data.quote_price?Math.round((data.quote_price.landprice/(data.number_adults+data.number_child))/data.duration):0,
    header:data.quote_identifier,
    flight_profit:"quote_price" in data && "airfare" in data.cost_price?(Math.round(data.quote_price.airfare-data.cost_price.airfare)>0?Math.round(data.quote_price.airfare-data.cost_price.airfare):0):0,
    land_profit:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round(data.quote_price.landprice-data.cost_price.landprice):0,
    land_profit_perc:"landprice" in data.quote_price && "landprice" in data.cost_price?Math.round((data.quote_price.landprice-data.cost_price.landprice)/data.cost_price.landprice*100):0,
    conv_quote:getconvquote(data.trip_id)
  }));

  const analyticsdatalistdisplay5 = resultarr3.map((data) => ({
    campaign: data.name,
    id: resultarr3.indexOf(data),
    status1: data.status1,
    status1p: data.status1p,
    status2: data.status2,
    status2p: data.status2p,
    status3: data.status3,
    status3p: data.status3p,
    status4: data.status4,
    status4p: data.status4p,
    total: data.total
  }));

  const analyticsdatalistdisplay = analytics.map((data) => ({
    day: data.day,
    id: analytics.indexOf(data),
    share: data.share,
    cancelled_trips: data.value,
  }));

  const analyticsdatalistdisplay2 = analytics2.map((data) => ({
    day: data.day,
    id: analytics2.indexOf(data),
    share: data.share,
    converted_trips: data.value,
  }));

  const analyticsdatalistdisplay3 = analytics3.map((data) => ({
    day: data.day,
    id: analytics3.indexOf(data),
    share: data.share,
    hot: data.hot,
    conv: data.conv  + "("+Math.round(data.conv/(data.hot-data.value)*100)+"%)",
    hot_trips: data.value,
    bo:data.bo,
  }));

  const analyticsdatalistdisplay4 = analytics4.map((data) => ({
    name: data.name,
    id: analytics4.indexOf(data),
    quoted_rncount: data.count,
    
  }));

  const getlastcomment=(data, number)=>{
    if(data.follow_up.length>number+1){
    for(let i=data.follow_up.length-1;i>=0;i--){
      if(data.follow_up[i-number] && "notes" in data.follow_up[i-number] && data.follow_up[i-number].notes !==""){
        return data.follow_up[i-number].notes
      }
    }
  }else{
    return ""
  }
  }

  const getcount=(name)=>{
    const temp=cohort4.filter(d=>d.name==name)
    return temp.length>0?temp[0].count:""
  }

  const analyticsdatalistdisplay9 = hot3.map((data) => ({
    id: listhottripData3.indexOf(data),
    trip_id:data.trip_id,
    owner:data.trip_owner,
    status:data.trip_status,
    destination:data.primary_destination,
    conv_date:gettimetoconvert(data),
    canc_time:gettimefromcancel(data),
    cust_name:data.cust_name,
    pax:"number_child" in data?data.number_adults+data.number_child:data.number_adults,
    hot_at:gethotdate(data),
    hvb:data.hot_verified_by,
    phone:data.primary_mobile_number,
    email:data.primary_email_id,
    //last_comment:getlastcomment(data, 0),
    //previous_comment:getlastcomment(data, 1),
  }));

  const analyticsdatalistdisplay9b = hot3.map((data) => ({
    id: listhottripData3.indexOf(data),
    trip_id:data.trip_id,
    owner:data.trip_owner,
    status:data.trip_status,
    destination:data.primary_destination,
    cust_name:data.cust_name,
    super_hot:data.super_hot_date,
    last_comment:data.follow_up.length>=1?data.follow_up[data.follow_up.length-1].notes:"",
    previous_comment:data.follow_up.length>=2?data.follow_up[data.follow_up.length-2].notes:"",
  }));

  const analyticsdatalistdisplay10 = pot3.map((data) => ({
    id: listpottripData.indexOf(data),
    trip_id:data.trip_id,
    owner:data.trip_owner,
    status:data.trip_status,
    destination:data.primary_destination,
    cust_name:data.cust_name,
    last_comment:data.follow_up.length>=1?data.follow_up[data.follow_up.length-1].notes:"",
    previous_comment:data.follow_up.length>=2?data.follow_up[data.follow_up.length-2].notes:"",
  }));

  const analyticsdatalistdisplay11 = cohort.map((data) => ({
    id: cohort.indexOf(data),
    month:data.name,
    count:data.count,
    
  }));

  const analyticsdatalistdisplay12 = cohort2.map((data) => ({
    id: cohort2.indexOf(data),
    month:data.name,
    count:data.count,
    count2:getcount(data.name)
  }));

  const analyticsdatalistdisplay13 = cohort3.map((data) => ({
    id: cohort3.indexOf(data),
    month:data.name,
    count:data.count,
    
  }));

  const analyticsdatalistdisplay14 = comparr.map((data) => ({
    id: comparr.indexOf(data),
    trip_id: data.trip_id,
    cust_name:data.cust_name,
    owner:data.trip_owner,
    destination:data.primary_destination,
    status:data.trip_status,
    comp_from:data.competition_from,
    comp_status:data.competition_status,
    
    
  }));

  const gridcellclick=(id)=>{
    window.open("/quotedataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  }

  const gridtripcellclick=(id)=>{
    window.open("/tripdataentry/" + id,'_blank');
    //console.log("/custdataentry/"+id);
  }

  const handleChange=()=>{
    setsearchbyqe(!searchbyqe)
  }

  const handleChange2=()=>{
    setsearchbysh(!searchbysh)
  }

  const changemonth=async(value)=>{
    var finarr=[], numarr=[]
    var x=getmonth(value)
    try{
    const data=await fetchleadsbydate2(new Date(x.startdate), new Date(x.enddate))
    //console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      numarr=[...numarr, data.data[i].mobile_number]
    }
   // console.log(numarr)
    const data2=await fetchleadsbynumber2(numarr)
    //console.log(data2.data)
    // for(let i=0; i<data.data.length; i++){
    //   //for(let i=0; i<100; i++){
    //   const data2=await fetchleadsbynumber2(data.data[i].mobile_number)
    //   console.log(i)
      for(let j=0; j<data2.data.length; j++){
        var month=new Date(data2.data[j].createdAt).getMonth()+1
        var year=new Date(data2.data[j].createdAt).getFullYear()
        var temp=month+"-"+year
        finarr=[...finarr, temp]
      }
    // }
    //console.log(finarr)
    const tempobj=countTextValues(finarr)
    //console.log(tempobj)
    setcohort(tempobj)
  }catch(err){
    console.log(err)
  }
  }

  const changemonth2=async(value)=>{
    var finarr=[], numarr=[], finarr2=[]
    var x=getmonth(value)
    try{
    const data=await searchconvTripsbyDate(new Date(x.startdate), new Date(x.enddate))
    console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      numarr=[...numarr, data.data[i].primary_mobile_number]
    }
    console.log(numarr)
    const data2=await fetchTripsbyNumber2(numarr)
    console.log(data2.data)
    // const data2=await fetchleadsbynumber2(numarr)
    // console.log(data2.data)
    // for(let i=0; i<data.data.length; i++){
    //   //for(let i=0; i<100; i++){
    //   const data2=await fetchleadsbynumber2(data.data[i].mobile_number)
    //   console.log(i)
      for(let j=0; j<data2.data.length; j++){
        var month=new Date(data2.data[j].createdAt).getMonth()+1
        var year=new Date(data2.data[j].createdAt).getFullYear()
        var temp=month+"-"+year
        finarr=[...finarr, temp]
      }
    var convtrips=data.data.filter(t=>t.trip_status=="Converted")
    console.log(convtrips)
   for(let j=0; j<convtrips.length; j++){
        var month2=new Date(convtrips[j].createdAt).getMonth()+1
        var year2=new Date(convtrips[j].createdAt).getFullYear()
        var temp2=month2+"-"+year2
        finarr2=[...finarr2, temp2]
      }
      const tempobj2=countTextValues(finarr2)
    console.log(tempobj2)
    setcohort4(tempobj2)
    const tempobj=countTextValues(finarr)
    console.log(tempobj)
    setcohort2(tempobj)
  }catch(err){
    console.log(err)
  }
  }

  const cohortsearch=async()=>{
    var finarr=[], numarr=[]
    
    try{
    const data=await fetchleadsbydate2(new Date(searchData17.startdate), new Date(searchData17.enddate))
    //console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      numarr=[...numarr, data.data[i].mobile_number]
    }
   // console.log(numarr)
    const data2=await fetchleadsbynumber2(numarr)
    //console.log(data2.data)
    // for(let i=0; i<data.data.length; i++){
    //   //for(let i=0; i<100; i++){
    //   const data2=await fetchleadsbynumber2(data.data[i].mobile_number)
    //   console.log(i)
      for(let j=0; j<data2.data.length; j++){
        var month=new Date(data2.data[j].createdAt).getMonth()+1
        var year=new Date(data2.data[j].createdAt).getFullYear()
        var temp=month+"-"+year
        finarr=[...finarr, temp]
      }
    // }
    //console.log(finarr)
    const tempobj=countTextValues(finarr)
    //console.log(tempobj)
    setcohort(tempobj)
  }catch(err){
    console.log(err)
  }
  }

  //console.log(cohort4)

   const cohortsearch2=async()=>{
    var finarr=[], numarr=[], finarr2=[]
    
    try{
    const data=await searchconvTripsbyDate(new Date(searchData17.startdate), new Date(searchData17.enddate))
    //console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      numarr=[...numarr, data.data[i].mobile_number]
    }
   // console.log(numarr)
    const data2=await fetchTripsbyNumber2(numarr)
    var convtrips=data2.data.filter(t=>t.trip_status=="Converted")
    console.log(convtrips)
    for(let j=0; j<convtrips.length; j++){
        var month2=new Date(convtrips[j].createdAt).getMonth()+1
        var year2=new Date(convtrips[j].createdAt).getFullYear()
        var temp2=month2+"-"+year2
        finarr2=[...finarr2, temp2]
      }
      for(let j=0; j<data2.data.length; j++){
        var month=new Date(data2.data[j].createdAt).getMonth()+1
        var year=new Date(data2.data[j].createdAt).getFullYear()
        var temp=month+"-"+year
        finarr=[...finarr, temp]
      }
    // }
    //console.log(finarr)
    const tempobj=countTextValues(finarr)
    const tempobj2=countTextValues(finarr2)
    console.log(tempobj2)
    setcohort(tempobj)
    setcohort4(tempobj2)
  }catch(err){
    console.log(err)
  }
  }


  var finarr3=[]
  var fintotal3=0
  const changemonth3=async(value)=>{
    var finarr=[], numarr=[]
    var x=getmonth(value)
    try{
    const data=await searchclosedTripsbyDate(new Date(x.startdate), new Date(x.enddate))
    console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      numarr=[...numarr, data.data[i].primary_mobile_number]
    }
    console.log(numarr)
    const data2=await fetchTripsbyNumber2(numarr)
    console.log(data2.data)
    // const data2=await fetchleadsbynumber2(numarr)
    // console.log(data2.data)
    // for(let i=0; i<data.data.length; i++){
    //   //for(let i=0; i<100; i++){
    //   const data2=await fetchleadsbynumber2(data.data[i].mobile_number)
    //   console.log(i)
      for(let j=0; j<data2.data.length; j++){
        var month=new Date(data2.data[j].createdAt).getMonth()+1
        var year=new Date(data2.data[j].createdAt).getFullYear()
        var temp=month+"-"+year
        finarr3=[...finarr3, temp]
      }
    // }
    // //console.log(finarr)
    const tempobj=countTextValues(finarr3)
    console.log(tempobj)
    setcohort3(tempobj)
  }catch(err){
    console.log(err)
  }
  }
  if(cohort3.length>0){
    fintotal3=getSumByKey(cohort3,"count")
  }

  const destinationchange=(event)=>{
    const {
      target: { value },
    } = event;
    setsearchData6({...searchData6, destination:
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value}
    );
  };

  const ownerchange=(event)=>{
    const {
      target: { value },
    } = event;
    setsearchData6({...searchData6, owner:
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value}
    );
  };

  const lpdata=async()=>{
    try{
      const data=await getlpdata(searchData8.start_date, searchData8.end_date)
      console.log(data.data)
      setlpset(data.data)
    }catch(err){
      console.log(err)
    }
  }

  var l15=[...lpset]
  const campaigns = getUnique(l15,"campaign");
const adSets = getUnique(l15,"ad_set");
const ads = getUnique(l15,"ad");
const versions = getUnique(l15,"version");
const lpVersions = getUnique(l15,"lp_version");
const sources = getUnique(l15,"source");
  if(filterData.source){
    l15=l15.filter(d=>d.source==filterData.source)
  }
  if(filterData.campaign){
    l15=l15.filter(d=>d.campaign==filterData.campaign)
  }
  if(filterData.ad_set){
    l15=l15.filter(d=>d.ad_set==filterData.ad_set)
  }
  if(filterData.ad){
    l15=l15.filter(d=>d.ad==filterData.ad)
  }
  if(filterData.version){
    l15=l15.filter(d=>d.version==filterData.version)
  }
  if(filterData.lp_version){
    l15=l15.filter(d=>d.lp_version==filterData.lp_version)
  }


  var lptotal={
        source:"Total",
        totalRecords:getSumByKey(l15,"totalRecords"),
        totalLeads:getSumByKey(l15,"totalLeads"),
        conversionRate:(getSumByKey(l15,"totalLeads")/getSumByKey(l15,"totalRecords")).toFixed(2),
      }
  
  l15=[...l15, lptotal]

   const analyticsdatalistdisplay15 = l15.map((data) => ({
    id: l15.indexOf(data),
    source: data.source,
    campaign:data.campaign,
    ad_set:data.ad_set,
    ad:data.ad,
    lp_version:data.lp_version,
    version:data.version,
    totalRecords:data.totalRecords,
    totalLeads:data.totalLeads,
    conversionRate:data.conversionRate,
    
  }));


  return (
    <div>
    <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Lead Quality by status
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData6({ ...searchData6, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(handlestatusSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          <Button
            onClick={preventDoubleClick(handlestatusSearch2)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Trip Search
          </Button>
          </div>
          <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destinationtype">Destination Type</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Destination Type"
              value={searchData6.destination_type}
              onChange={(e) =>
                setsearchData6({ ...searchData6, destination_type: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"International"}>International</MenuItem>
            <MenuItem value={"Domestic"}>Domestic</MenuItem>
            <MenuItem value={"Others"}>Others</MenuItem>
              {/* {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })} */}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="mode">Mode?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="mode"
              value={searchData6.status_present}
              onChange={(e) =>
                setsearchData6({ ...searchData6, mode: e.target.value })
              }
            >
            <MenuItem value={"Salesperson"}>Salesperson</MenuItem>
             <MenuItem value={"Decision Stage"}>Decision Stage</MenuItem>
             <MenuItem value={"Time to book"}>Time to book</MenuItem>
             <MenuItem value={"Quality"}>Quality</MenuItem>
             <MenuItem value={"Destination"}>Destination</MenuItem>
             <MenuItem value={"Channel"}>Channel</MenuItem>
             <MenuItem value={"Campaign"}>Campaign</MenuItem>
             <MenuItem value={"Date"}>Date</MenuItem>
             <MenuItem value={"Potential"}>Potential</MenuItem>
             <MenuItem value={"Reach"}>Reach</MenuItem>
             <MenuItem value={"First Reach Attempt"}>First Reach Attempt</MenuItem>
             <MenuItem value={"FC Time"}>FC Time</MenuItem>
             <MenuItem value={"WA Only"}>WA Only</MenuItem>
             <MenuItem value={"Pax"}>Pax</MenuItem>
             <MenuItem value={"Budget"}>Budget</MenuItem>
             <MenuItem value={"Airport"}>Airport</MenuItem>
             <MenuItem value={"Flight Req"}>Flight Req</MenuItem>
             <MenuItem value={"Canc Reason"}>Canc Reason</MenuItem>
             <MenuItem value={"Canc Reason Notes"}>Canc Reason Notes</MenuItem>
             <MenuItem value={"Support Owner"}>Support Owner</MenuItem>
             <MenuItem value={"Created At"}>Created At</MenuItem>
             <MenuItem value={"Time To Travel"}>Time To Travel</MenuItem>
             <MenuItem value={"Ad"}>Ad</MenuItem>
             <MenuItem value={"Sub-platform"}>Sub-platform</MenuItem>
             <MenuItem value={"Initial Quality"}>Initial Quality</MenuItem>
             <MenuItem value={"Interest WA"}>Interest WA</MenuItem>
             <MenuItem value={"Interest Urgent"}>Interest Urgent</MenuItem>
             <MenuItem value={"Customer Type"}>Customer Type</MenuItem>
             <MenuItem value={"Lead Place Count"}>Lead Place Count</MenuItem>
             <MenuItem value={"Lead Assigned By"}>Lead Assigned By</MenuItem>
             <MenuItem value={"Fast Reach"}>Fast Reach</MenuItem>
             <MenuItem value={"Fast Reach Attempted"}>Fast Reach Attempted</MenuItem>
             <MenuItem value={"Manual Fast Reach"}>Manual Fast Reach</MenuItem>
             <MenuItem value={"Manual Fast Reach Attempted"}>Manual Fast Reach Attempted</MenuItem>
             <MenuItem value={"Travel Date"}>Travel Date</MenuItem>
             <MenuItem value={"TL"}>TL</MenuItem>
             <MenuItem value={"Meta Campaign"}>Meta Campaign</MenuItem>
             <MenuItem value={"Landing Page"}>Landing Page</MenuItem>
             <MenuItem value={"Ref Code"}>Ref Code</MenuItem>
             <MenuItem value={"Model"}>Model</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="stage">Decision Stage?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="stage"
              value={searchData6.decision_stage}
              onChange={(e) =>
                setsearchData6({ ...searchData6, decision_stage: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value="Looking for information only. Will plan later">Looking for information only. Will plan later</MenuItem>
                    <MenuItem value="Thinking about going on a trip but nothing has been decided yet">Thinking about going on a trip but nothing has been decided yet</MenuItem>
                    <MenuItem value="Definitely going on a trip. Planning in progress">Definitely going on a trip. Planning in progress</MenuItem>
                    <MenuItem value="Travel date, destination and people travelling all finalized. Just looking for a package">Travel date, destination and people travelling all finalized. Just looking for a package</MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="leadstatus2">Lead status?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="leadstatus2"
              value={searchData6.status_present}
              onChange={(e) =>
                setsearchData6({ ...searchData6, status_present: e.target.value })
              }
            >
            {/* {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })} */}
             <MenuItem value={"All"}>All Leads</MenuItem>
             <MenuItem value={"OS"}>Only with status</MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">Campaign</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="campaign"
              value={searchData6.campaign}
              onChange={(e) =>
                setsearchData6({ ...searchData6, campaign: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Pure Organic"}>Pure Organic</MenuItem>
             {campaigninfo.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="ttb">Time to book</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="ttb"
              value={searchData6.ttb}
              onChange={(e) =>
                setsearchData6({ ...searchData6, ttb: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value="I will book within 2-3 days">I will book within 2-3 days</MenuItem>
            <MenuItem value="I will book within a week">I will book within a week</MenuItem>
            <MenuItem value="I will book within a month">I will book within a month</MenuItem>
            <MenuItem value="Nothing decided as of now">Nothing decided as of now</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="channel">Channel</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="channel"
              value={searchData6.lead_platform}
              onChange={(e) =>
                setsearchData6({ ...searchData6, lead_platform: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value="Meta">Meta</MenuItem>
            <MenuItem value="TripCrafters">TripCrafters</MenuItem>
            <MenuItem value={"TripClap"}>TripClap</MenuItem>
            <MenuItem value={"PayTM"}>PayTM</MenuItem>
            <MenuItem value={"Whatsapp"}>Whatsapp</MenuItem>
            <MenuItem value="Manual">Manual</MenuItem>
            <MenuItem value="Google">Google</MenuItem>
             <MenuItem value="Poptin">Poptin</MenuItem>
            <MenuItem value="Organic">Organic</MenuItem>
            <MenuItem value="Reference">Reference</MenuItem>
            <MenuItem value="Affiliate">Affiliate</MenuItem>
            </Select>
          </FormControl>
         <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="flightreq">Flight Required</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="flightreq"
              value={searchData6.flightreq}
              onChange={(e) =>
                setsearchData6({ ...searchData6, flightreq: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={"Null"}>Null</MenuItem>
             
             
            </Select>
          </FormControl>
           <FormControl>
        <InputLabel>Lead Owner</InputLabel>
        <Select
          label="Owner"
          multiple
          className={classes.textField}
          value={"owner" in searchData6?searchData6.owner:[]}
          onChange={ownerchange}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
        >
          
       <MenuItem key={"Clear"} value={"Clear"}>
              <Checkbox checked={"owner" in searchData6 && searchData6.owner.includes("Clear")} />
              <ListItemText primary={"Clear"} />
            </MenuItem>
           
          {emp.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={"owner" in searchData6 && searchData6.owner.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
       <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">SS Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.support_owner}
              onChange={(e) =>
                setsearchData6({ ...searchData6, support_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            {sslist.map(s=>
            <MenuItem value={s}>{s}</MenuItem>
           
             )}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Manual FR</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.manual_fr}
              onChange={(e) =>
                setsearchData6({ ...searchData6, manual_fr: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Manual FR Attempted</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.manual_fr_attempted}
              onChange={(e) =>
                setsearchData6({ ...searchData6, manual_fr_attempted: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Manual FR Failed</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.manual_fr_failed}
              onChange={(e) =>
                setsearchData6({ ...searchData6, manual_fr_failed: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={0}>0</MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="quality">Quality?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="quality"
              value={searchData6.quality}
              onChange={(e) =>
                setsearchData6({ ...searchData6, quality: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={"Rhodium"}>Rhodium</MenuItem>
           <MenuItem value={"Platinum"}>Platinum</MenuItem>
           <MenuItem value={"Diamond"}>Diamond</MenuItem>
           <MenuItem value={"Titanium"}>Titanium</MenuItem>
           <MenuItem value={"Gold"}>Gold</MenuItem>
           <MenuItem value={"Silver"}>Silver</MenuItem>
           <MenuItem value={"Copper"}>Copper</MenuItem>
           <MenuItem value={"Iron"}>Iron</MenuItem>
           <MenuItem value={"Old High Quality"}>Old High Quality</MenuItem> 
           <MenuItem value={"Old Low Quality"}>Old Low Quality</MenuItem> 
           <MenuItem value={"High Quality"}>High Quality</MenuItem> 
           <MenuItem value={"Low Quality"}>Low Quality</MenuItem> 
            </Select>
          </FormControl>
         
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="passport">Passport Status?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="passport"
              value={searchData6.passport}
              onChange={(e) =>
                setsearchData6({ ...searchData6, passport: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={"Yes, all passengers have passports with more than 6 months validity"}>Yes, all passengers have passports with more than 6 months validity</MenuItem>
           <MenuItem value={"No, but already applied for issuance/renewal"}>No, but already applied for issuance/renewal</MenuItem>
           <MenuItem value={"No, yet to apply"}>No, yet to apply</MenuItem>
          
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="quote">Quote Status?</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="quote"
              value={searchData6.quote}
              onChange={(e) =>
                setsearchData6({ ...searchData6, quote: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={"Yes, I am already comparing multiple quotes"}>Yes, I am already comparing multiple quotes</MenuItem>
           <MenuItem value={"No, but planning to get quotes"}>No, but planning to get quotes</MenuItem>
           <MenuItem value={"No, have no such plans"}>No, have no such plans</MenuItem>
          
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="passport">Fast Reach</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="fastreach"
              value={searchData6.fast_reach}
              onChange={(e) =>
                setsearchData6({ ...searchData6, fast_reach: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={1}>1</MenuItem>
           <MenuItem value={0}>0</MenuItem>
          
          
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="passport">Fast Reach Attempted</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="fastreachattempted"
              value={searchData6.fast_reach_attempted}
              onChange={(e) =>
                setsearchData6({ ...searchData6, fast_reach_attempted: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={1}>1</MenuItem>
           <MenuItem value={0}>0</MenuItem>
          
          
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="leadcancreason">Lead Canc Reason</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="leadcancreason"
              value={searchData6.lead_canc_reason}
              onChange={(e) =>
                setsearchData6({ ...searchData6, lead_canc_reason: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Wrong number"}>Wrong number</MenuItem>
                <MenuItem value={"Number unreachable"}>
                  Number unreachable
                </MenuItem>
                <MenuItem value={"Cancelled by marketing"}>Cancelled by marketing</MenuItem>
                <MenuItem value={"Duplicate Lead"}>Duplicate Lead</MenuItem>
                <MenuItem value={"Already Booked"}>Already Booked</MenuItem>
                <MenuItem value={"Denied placing lead"}>Denied placing lead</MenuItem>
                 <MenuItem value={"Not serving destination"}>Not serving destination</MenuItem>
                                <MenuItem value={"Budget Problem"}>Budget Problem</MenuItem>
                                <MenuItem value={"Solo Traveller"}>Solo Traveller</MenuItem>
                <MenuItem value={"Others"}>Others</MenuItem>
          
          
            </Select>
          </FormControl>
         <FormControl>
        <InputLabel>Destinations</InputLabel>
        <Select
          label="Destinations"
          multiple
          className={classes.textField}
          value={"destination" in searchData6?searchData6.destination:[]}
          onChange={destinationchange}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
        >
         <MenuItem key={"Clear"} value={"Clear"}>
              <Checkbox checked={"destination" in searchData6 && searchData6.destination.includes("Clear")} />
              <ListItemText primary={"Clear"} />
            </MenuItem>
           <MenuItem value={"Bali"} key={"Bali"}>
              <Checkbox checked={"destination" in searchData6 && searchData6.destination.includes("Bali")} />
              <ListItemText primary={"Bali"} />
           </MenuItem>
            <MenuItem value={"Abu Dhabi"} key={"Abu Dhabi"}>
              <Checkbox checked={"destination" in searchData6 && searchData6.destination.includes("Abu Dhabi")} />
              <ListItemText primary={"Abu Dhabi"} />
           </MenuItem>
           
          {dest.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={"destination" in searchData6 && searchData6.destination.includes(name)} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
       <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="leadcancreason">TL</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="leadcancreason"
              value={searchData6.tl}
              onChange={(e) =>
                setsearchData6({ ...searchData6, tl: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
            {tlsplist && tlsplist.map(t=>
            <MenuItem value={t.tl}>{t.tl}</MenuItem>
            )}
          
          
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="customertype">Customer Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="leadcancreason"
              value={searchData6.cust_type}
              onChange={(e) =>
                setsearchData6({ ...searchData6, cust_type: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"First Time Customer"}>First Time Customer</MenuItem>
            <MenuItem value={"Potential Customer"}>Potential Customer</MenuItem>
             <MenuItem value={"Repeat Customer"}>Repeat Customer</MenuItem>
          
          
            </Select>
          </FormControl>
              <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Meta Campaign</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.lead_meta_campaign}
              onChange={(e) =>
                setsearchData6({ ...searchData6, lead_meta_campaign: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             
             {metacampaigninfo.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
                  <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Meta Ad</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.lead_meta_ad}
              onChange={(e) =>
                setsearchData6({ ...searchData6, lead_meta_ad: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             
             {metaadinfo.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Meta Sub Platform</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData6.meta_sub_platform}
              onChange={(e) =>
                setsearchData6({ ...searchData6, meta_sub_platform: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             
             {metasubplatform.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="model">Model</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="model"
              value={searchData6.model}
              onChange={(e) =>
                setsearchData6({ ...searchData6, model: e.target.value })
              }
            >
           <MenuItem value={""}>Clear</MenuItem>
           <MenuItem value={"Alpha"}>Alpha</MenuItem>
           <MenuItem value={"Beta"}>Beta</MenuItem>
          
            </Select>
          </FormControl>
        </div>
        <div align="center">
          <Typography variant="h6" align="center">Lead Quality: FR Qualifiation: {frq} % || FR+ :{frperc} % || Titanium: {titaniumcount} % || Trips Created HQ %: {((hqtrips.length/hqleads.length)*100).toFixed(1)} || NR Canc:{((nrcanc.length/totalcanc.length)*100).toFixed(1)}</Typography>
        </div>
        {analyticsdatalistdisplay6.length > 0 ? (
          <div style={{ height: 1000, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay6}
              columns={listtripData2.length>0?columns10:columns6}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
    <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          New Quotes
        </Typography>
        <FormControlLabel control={<Switch  onChange={handleChange} color="secondary" />} label="Search by QE"/>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(handlequoteSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Destination"
              value={filterData.destination}
              onChange={(e) =>
                setfilterData({ ...filterData, destination: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="status">Status</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Status"
              value={filterData.destination}
              onChange={(e) =>
                setfilterData({ ...filterData, status: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Closed"}>Closed</MenuItem>
              <MenuItem value={"Hot"}>Hot</MenuItem>
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
              <MenuItem value={"Dropped After Booking"}>Dropped After Booking
              </MenuItem>
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={filterData.owner}
              onChange={(e) =>
                setfilterData({ ...filterData, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="budget">Budget</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="budget"
              value={filterData.budget}
              onChange={(e) =>
                setfilterData({ ...filterData, budget: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Cheapest"}>Cheapest</MenuItem>
            <MenuItem value={"Low"}>Low</MenuItem>
            <MenuItem value={"Medium"}>Medium</MenuItem>
            <MenuItem value={"High"}>High</MenuItem>
            <MenuItem value={"Luxury"}>Luxury</MenuItem>
             
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="type">Cust Type</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="type"
              value={filterData.budget}
              onChange={(e) =>
                setfilterData({ ...filterData, type: e.target.value })
              }
            >
             <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Romantic"}>Romantic</MenuItem>
                      <MenuItem value={"Family with kids"}>Family with kids</MenuItem>
                      <MenuItem value={"Family without kids"}>Family without kids</MenuItem>
                      <MenuItem value={"Party lovers"}>Party lovers</MenuItem>
                      <MenuItem value={"Adventure junkies"}>Adventure junkies</MenuItem>
                      <MenuItem value={"Generic"}>Generic</MenuItem>
             
             
            </Select>
          </FormControl>
          </div>
          {analyticsdatalistdisplay7.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay7} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay7.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay7}
              onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.quote_id)}
              columns={columns7}
              autoPageSize
              // pageSize={20}
              // autoHeight
            ></DataGrid>
            <br></br>
            <br></br>
           
            
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
         {spwiselist.length>0?(
               <div style={{ height: 1200, width: "100%" }}>
             <DataGrid
              rows={spwiselist}
              // onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.quote_id)}
              columns={columns7b}
              autoPageSize
             
            ></DataGrid>
            </div>
            ):("")}
             {destwiselist.length>0?(
               <div style={{ height: 1200, width: "100%" }}>
             <DataGrid
              rows={destwiselist}
              // onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.quote_id)}
              columns={columns7c}
              autoPageSize
             
            ></DataGrid>
            </div>
            ):("")}
      </Paper>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Hot Today
        </Typography>
         <FormControlLabel control={<Switch  onChange={handleChange2} color="secondary" />} label="Search by Super Hot"/>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Hot On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData9({ ...searchData9, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Hot On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData9({ ...searchData9, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="trip owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Trip Owner"
              required
              InputLabelProps={{ shrink: true }}
              value={searchData9.trip_owner}
              onChange={(e) =>
                setsearchData9({ ...searchData9, trip_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
          </FormControl>
          
          <Button
            onClick={preventDoubleClick(handlehotSearch2)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        {analyticsdatalistdisplay9.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay9} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay9.length > 0 ? (
          <div style={{ height: 750, width: "100%" }}>
            <DataGrid
              rows={searchbysh?analyticsdatalistdisplay9b:analyticsdatalistdisplay9}
              columns={searchbysh?columns8b:columns8}
              autoPageSize
              // pageSize={10}
              // autoHeight
              onCellDoubleClick={(getValue) =>
                gridtripcellclick(getValue.row.trip_id)
            }
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Potential Today
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Potential On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData10({ ...searchData10, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Potential On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData10({ ...searchData10, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="trip owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Trip Owner"
              required
              InputLabelProps={{ shrink: true }}
              value={searchData10.trip_owner}
              onChange={(e) =>
                setsearchData10({ ...searchData10, trip_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
          
            <InputLabel id="Trip Status">Trip Status</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="Trip Status"
              value={searchData10.trip_status}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData10({ ...searchData10, trip_status: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"New"}>New</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Hot"}>Hot</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
              <MenuItem value={"Converted"}>Converted</MenuItem>
              <MenuItem value={"Postponed"}>Postponed</MenuItem>
              <MenuItem value={"Closed"}>Closed</MenuItem>
            </Select>
          </FormControl>   
          
          <Button
            onClick={preventDoubleClick(handlepotSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        {analyticsdatalistdisplay10.length > 0 ? (
          <div style={{ height: 750, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay10}
              columns={columns8}
              autoPageSize
              // pageSize={10}
              // autoHeight
              onCellDoubleClick={(getValue) =>
                gridtripcellclick(getValue.row.trip_id)
            }
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Hot Trips - Day Matrix -Median is: {medhot ? medhot : 0} || Average
          is:{avghot}
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Hot On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData3({ ...searchData3, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Hot On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData3({ ...searchData3, end_date: e.target.value })
            }
          />
           <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Destination"
              value={searchData3.destination}
              onChange={(e) =>
                setsearchData3({ ...searchData3, destination: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="trip owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Trip Owner"
              required
              InputLabelProps={{ shrink: true }}
              value={searchData3.trip_owner}
              onChange={(e) =>
                setsearchData3({ ...searchData3, trip_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 320,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 5,
            }}
          >
            <InputLabel id="channel">Trip Channel</InputLabel>
            <Select
              displayEmpty
              classname={classes.textField}
              labelId="channel"
              onChange={(e) => setsearchData3( {...searchData3, trip_channel: e.target.value})}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"Facebook"}>Facebook</MenuItem>
              <MenuItem value={"Instagram"}>Instagram</MenuItem>
              <MenuItem value={"Meta"}>Meta</MenuItem>
              <MenuItem value={"Manual"}>Manual</MenuItem>
              <MenuItem value={"Google"}>Google</MenuItem>
              <MenuItem value={"TripCrafters"}>TripCrafters</MenuItem>
              <MenuItem value={"TripClap"}>TripClap</MenuItem>
              <MenuItem value={"PayTM"}>PayTM</MenuItem>
              <MenuItem value={"Reference"}>Reference</MenuItem>
              <MenuItem value={"Tripoto"}>Tripoto</MenuItem>
              <MenuItem value={"Organic"}>Organic</MenuItem>
              <MenuItem value={"Email"}>Email</MenuItem>
              <MenuItem value={"Meta"}>Meta</MenuItem>
              <MenuItem value={"Unknown"}>Others</MenuItem>
            </Select>
          </FormControl>

          <Button
            onClick={preventDoubleClick(handlehotSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        {analyticsdatalistdisplay3.length > 0 ? (
          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay3}
              columns={columns3}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Competition Today
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Comp On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData11({ ...searchData11, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Comp On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData11({ ...searchData11, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="trip owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Trip Owner"
              required
              InputLabelProps={{ shrink: true }}
              value={searchData11.trip_owner}
              onChange={(e) =>
                setsearchData11({ ...searchData11, trip_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
            </Select>
          </FormControl>
          
          <Button
            onClick={preventDoubleClick(handlecompSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        {/* {analyticsdatalistdisplay14.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay14} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")} */}
        {analyticsdatalistdisplay14.length > 0 ? (
          <div style={{ height: 750, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay14}
              columns={columns11}
              autoPageSize
              // pageSize={10}
              // autoHeight
              onCellDoubleClick={(getValue) =>
                gridtripcellclick(getValue.row.trip_id)
            }
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Converted Trips - Day Matrix -Median is: {medconv ? medconv : 0} ||
          Average is:{avgconv}
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Converted On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData2({ ...searchData2, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Converted On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData2({ ...searchData2, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(handleconvSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
        {analyticsdatalistdisplay2.length > 0 ? (
          <div style={{ height: 450, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay2}
              columns={columns2}
              autoPageSize
              // pageSize={6}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Cancelled Trips - Day Matrix -Median is: {medcanc ? medcanc : 0} ||
          Average is:{avgcanc}
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Cancelled On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData({ ...searchData, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Cancelled On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData({ ...searchData, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(handlecancSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
        {analyticsdatalistdisplay.length > 0 ? (
          <div style={{ height: 450, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay}
              columns={columns}
              autoPageSize
              // pageSize={6}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
        {cuser=="Debayan"?(
          <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Lead Cohort
        </Typography>
        <div align="center">
         <TextField
            variant="outlined"
            type="date"
            label="Start On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData17({ ...searchData17, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Start On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData17({ ...searchData17, end_date: e.target.value })
            }
          />
          <Button
            onClick={cohortsearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData.month}
                onChange={(e) => changemonth(e.target.value)}
              >
                <MenuItem value={"January 2023"}>January 2023</MenuItem>
                <MenuItem value={"February 2023"}>February 2023</MenuItem>
                <MenuItem value={"March 2023"}>March 2023</MenuItem>
                <MenuItem value={"April 2023"}>April 2023</MenuItem>
                <MenuItem value={"May 2023"}>May 2023</MenuItem>
                <MenuItem value={"June 2023"}>June 2023</MenuItem>
                <MenuItem value={"July 2023"}>July 2023</MenuItem>
                <MenuItem value={"August 2023"}>August 2023</MenuItem>
                <MenuItem value={"September 2023"}>September 2023</MenuItem>
                <MenuItem value={"October 2023"}>October 2023</MenuItem>
                <MenuItem value={"November 2023"}>November 2023</MenuItem>
                <MenuItem value={"December 2023"}>December 2023</MenuItem>
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
          

          
        </div>
        {role=="Admin" && analyticsdatalistdisplay11.length>0?(<div>
                   <CSVLink data={analyticsdatalistdisplay11} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay11.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay11}
              columns={columns9}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
        ):("")}
        {cuser=="Debayan"?(
          <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Converted Trip Cohort
        </Typography>
        <div align="center">
        <TextField
            variant="outlined"
            type="date"
            label="Start On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData17({ ...searchData17, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Start On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData17({ ...searchData17, end_date: e.target.value })
            }
          />
          <Button
            onClick={cohortsearch2}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData.month}
                onChange={(e) => changemonth2(e.target.value)}
              >
                <MenuItem value={"January 2023"}>January 2023</MenuItem>
                <MenuItem value={"February 2023"}>February 2023</MenuItem>
                <MenuItem value={"March 2023"}>March 2023</MenuItem>
                <MenuItem value={"April 2023"}>April 2023</MenuItem>
                <MenuItem value={"May 2023"}>May 2023</MenuItem>
                <MenuItem value={"June 2023"}>June 2023</MenuItem>
                <MenuItem value={"July 2023"}>July 2023</MenuItem>
                <MenuItem value={"August 2023"}>August 2023</MenuItem>
                <MenuItem value={"September 2023"}>September 2023</MenuItem>
                <MenuItem value={"October 2023"}>October 2023</MenuItem>
                <MenuItem value={"November 2023"}>November 2023</MenuItem>
                <MenuItem value={"December 2023"}>December 2023</MenuItem>
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
          

          {/* <Button
            onClick={handlehotelSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button> */}
        </div>
        {role=="Admin" && analyticsdatalistdisplay12.length>0?(<div>
                   <CSVLink data={analyticsdatalistdisplay12} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay12.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay12}
              columns={columns9}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
        ):("")}
        {cuser=="Debayan"?(
          <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          {"Closed Trip Cohort - Total: " + fintotal3}
        </Typography>
        <div align="center">
        <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData.month}
                onChange={(e) => changemonth3(e.target.value)}
              >
                <MenuItem value={"January 2023"}>January 2023</MenuItem>
                <MenuItem value={"February 2023"}>February 2023</MenuItem>
                <MenuItem value={"March 2023"}>March 2023</MenuItem>
                <MenuItem value={"April 2023"}>April 2023</MenuItem>
                <MenuItem value={"May 2023"}>May 2023</MenuItem>
                <MenuItem value={"June 2023"}>June 2023</MenuItem>
                <MenuItem value={"July 2023"}>July 2023</MenuItem>
                <MenuItem value={"August 2023"}>August 2023</MenuItem>
                <MenuItem value={"September 2023"}>September 2023</MenuItem>
                <MenuItem value={"October 2023"}>October 2023</MenuItem>
                <MenuItem value={"November 2023"}>November 2023</MenuItem>
                <MenuItem value={"December 2023"}>December 2023</MenuItem>
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
          

          {/* <Button
            onClick={handlehotelSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button> */}
        </div>
        {role=="Admin" && analyticsdatalistdisplay13.length>0?(<div>
                   <CSVLink data={analyticsdatalistdisplay13} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay13.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay13}
              columns={columns9}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
        ):("")}

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Quotes from Trips
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData8({ ...searchData8, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData8({ ...searchData8, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(handletripSearch)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        <div align="center">
        {analyticsdatalistdisplay8.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay8} headers={cheaders}>Download CSV</CSVLink>
                   </div>
                ):("")}
                </div>
        {analyticsdatalistdisplay8.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay8}
              onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.quote_id)}
              columns={columns7}
              autoPageSize
              // pageSize={20}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          LP Data
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData8({ ...searchData8, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData8({ ...searchData8, end_date: e.target.value })
            }
          />

          <Button
            onClick={preventDoubleClick(lpdata)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          <div align="center">
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">Source</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="campaign"
              value={filterData.source}
              onChange={(e) =>
                setfilterData({ ...filterData, source: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {sources.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
             <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">Campaign</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="campaign"
              value={filterData.campaign}
              onChange={(e) =>
                setfilterData({ ...filterData, campaign: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {campaigns.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">Ad Set</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="ad_set"
              value={filterData.ad_set}
              onChange={(e) =>
                setfilterData({ ...filterData, ad_set: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {adSets.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="ad">Ad</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="ad"
              value={filterData.ad}
              onChange={(e) =>
                setfilterData({ ...filterData, ad: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {ads.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">LP Number</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="lp_version"
              value={filterData.lp_version}
              onChange={(e) =>
                setfilterData({ ...filterData, lp_version: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {lpVersions.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
            <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="campaign">Version</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="version"
              value={filterData.version}
              onChange={(e) =>
                setfilterData({ ...filterData, version: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
             {versions.map((cam) => {
                return <MenuItem value={cam}>{cam}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          </div>
          {/* <Button
            onClick={TestTClead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Test (Do not use)
          </Button> */}
        </div>
        {/* <div align="center">
        {analyticsdatalistdisplay8.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay8} headers={cheaders}>Download CSV</CSVLink>
                   </div>
                ):("")}
                </div> */}
        {analyticsdatalistdisplay15.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay15}
              //onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.quote_id)}
              columns={columns15}
              autoPageSize
              // pageSize={20}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default Analytics2;
